// // import React, { useCallback, useMemo } from 'react';
// // import { useLocation } from 'react-router-dom';
// // import { useDispatch, useSelector } from 'react-redux';
// // import { Scope } from '@unform/core';
// // import {
// //   MdDelete,
// //   MdChevronLeft,
// //   MdChevronRight,
// //   MdShoppingCart,
// //   MdArrowBack,
// // } from 'react-icons/md';

// // import { AppError } from '../../../errors/AppError';

// // import {
// //   atualizaQuantidadeRequest,
// //   atualizaItemOSRequest,
// //   removeCarrinho,
// //   limpaCarrinho,
// // } from '../../../store/modules/cart/actions';

// // import history from '../../../services/history';
// // import api from '../../../services/api';

// // import { opTipoAcao } from '../../../lib/const';
// // import {
// //   sendServerEmail,
// //   // sendServerWhatsApp,
// //   labelExtExtra01,
// //   labelExtExtra02,
// //   labelExtExtra03,
// //   labelExtExtra04,
// //   criaItemOSSisma,
// //   enviaEmailSolicitacao,
// //   usaMotivoFalha,
// //   usaAgenteCausa,
// //   usaSecaoTrab,
// //   utilizaSolicitarPecas,
// // } from '../../../lib/paramUtils';
// // import { toCSV } from '../../../lib/csv-core';

// // import ActionMenu from '../../../components/ActionMenu';

// // import TitleBar from '../../../components/TitleBar';

// // import { Form } from '../../../components/Form';
// // import InputViewer from '../../../components/Form/Input/Viewer';
// // import Select from '../../../components/Form/Input/Select';

// // import { RowMaster } from '../../../components/Table';

// // import { emailTipo } from '../../Usuario/_usuario-email';

// // import {
// //   Container,
// //   Cart,
// //   Wrapper,
// //   Section,
// //   Table,
// //   Footer,
// //   WrapperItemOS,
// //   ItemOSTitle,
// //   ItemOSLabel,
// //   ItemOSTableLabel,
// //   ItemOSTableContent,
// //   WrapperTableItemOS,
// // } from './styles';
// // import {
// //   BACK_TO_CATALOG,
// //   BROWSE_CATALOG_AND_ADD_PARTS,
// //   EXPORT_SHOPPING_LIST,
// //   ITEM,
// //   ITEMS,
// //   MANUFACTURER,
// //   MODEL,
// //   NO_ERP_CODE_RELATED_TO_MATERIAL,
// //   NO_ITEM_ADDED_TO_CART,
// //   opIdiomaCatalogo,
// //   OTHER_INFORMATION,
// //   REQUEST_PARTS,
// //   REQUEST_QUOTE,
// //   REQUESTER,
// //   REVIEW_ITEMS_BEFORE_SUBMITTING,
// //   SELECTED_MATERIALS,
// //   YOUR_REQUEST,
// // } from '../../../lib/idiomaAppOptions';
// // // import { whatsAppTipo } from '../../WhatsApp';

// // function Carrinho() {
// //   const location = useLocation();
// //   const dispatch = useDispatch();

// //   const selectUser = useSelector((state) => state.user);

// //   /** idioma do catálogo escolhido pelo usuário (null = padrão) */
// //   const idiomaCatalogo = useSelector(
// //     (state) => state.param.idiomaCatalogo || null
// //   );

// //   const idioma = idiomaCatalogo || opIdiomaCatalogo.BR;

// //   const itensCarrinho = useSelector((state) => {
// //     const { cart, user } = state;

// //     /** dados do carrinho */
// //     const {
// //       items,
// //       order: {
// //         extCodiDiv2,
// //         extNumeOS,
// //         extItemOS,
// //         extObservacao,
// //         extUsuario,
// //         extExtra01,
// //         extExtra02,
// //         extExtra03,
// //         extExtra04,
// //       },
// //     } = cart;

// //     /** dados do usuário */
// //     const { profile } = user || {};
// //     const { name = '' } = profile || {};

// //     /** percorre todos os itens do carrinho */
// //     const itens = items.map((item) => {
// //       const {
// //         materialFabricante,
// //         paginaCatalogo,
// //         itemOS,
// //         partnumber,
// //         ...itemRestante
// //       } = item;

// //       const {
// //         catalogo: { modelo },
// //       } = paginaCatalogo;

// //       // extItemOS.push('0 - Inserir Item Novo na OS');

// //       return {
// //         ...itemRestante,
// //         ...materialFabricante,
// //         itemOS,
// //         itemOSFormatado: extItemOS.map((sequencia) => ({
// //           value: sequencia.value,
// //           label: sequencia.label,
// //         })),
// //         paginaCatalogo,
// //         modelo: modelo.map((m) => m.descricao).join(', '),
// //         partnumber,
// //       };
// //     });

// //     const extObservacaoFormatada = extObservacao || '';

// //     return {
// //       extCodiDiv2,
// //       extNumeOS,
// //       extObservacao: extObservacaoFormatada.split('$n').join('\r\n'),
// //       extUsuario,
// //       extExtra01,
// //       extExtra02,
// //       extExtra03,
// //       extExtra04,
// //       nome: name,
// //       itens,
// //     };
// //   });

// //   const { app, action } = useSelector((state) => state.auth || {});

// //   const handleExcluir = useCallback(
// //     (idCatalogo, idPagina, idItem, idMaterial, materialEmpresa) => {
// //       const codimate = materialEmpresa ? materialEmpresa.codimate : null;

// //       dispatch(
// //         removeCarrinho(idCatalogo, idPagina, idItem, idMaterial, codimate)
// //       );
// //     },
// //     [dispatch]
// //   );

// //   const handleAdicionar = useCallback(
// //     (
// //       idCatalogo,
// //       idPagina,
// //       idItem,
// //       idMaterial,
// //       materialEmpresa,
// //       quantidade = 1
// //     ) => {
// //       const codimate = materialEmpresa ? materialEmpresa.codimate : null;

// //       const itemIndex = codimate
// //         ? itensCarrinho.itens.findIndex(
// //             (item) =>
// //               item.idCatalogo === idCatalogo &&
// //               item.idPagina === idPagina &&
// //               item.idItem === idItem &&
// //               item.idMaterial === idMaterial &&
// //               item.materialEmpresa.codimate === codimate
// //           )
// //         : itensCarrinho.itens.findIndex(
// //             (item) =>
// //               item.idCatalogo === idCatalogo &&
// //               item.idPagina === idPagina &&
// //               item.idItem === idItem &&
// //               item.idMaterial === idMaterial
// //           );

// //       if (itemIndex >= 0) {
// //         const quantidadeTotal =
// //           itensCarrinho.itens[itemIndex].quantidadeTotal + quantidade;

// //         dispatch(
// //           atualizaQuantidadeRequest(
// //             idCatalogo,
// //             idPagina,
// //             idItem,
// //             idMaterial,
// //             quantidadeTotal,
// //             codimate
// //           )
// //         );
// //       }
// //     },
// //     [itensCarrinho, dispatch]
// //   );

// //   const handleRemover = useCallback(
// //     (
// //       idCatalogo,
// //       idPagina,
// //       idItem,
// //       idMaterial,
// //       materialEmpresa,
// //       quantidade = 1
// //     ) => {
// //       const codimate = materialEmpresa ? materialEmpresa.codimate : null;

// //       const itemIndex = codimate
// //         ? itensCarrinho.itens.findIndex(
// //             (item) =>
// //               item.idCatalogo === idCatalogo &&
// //               item.idPagina === idPagina &&
// //               item.idItem === idItem &&
// //               item.idMaterial === idMaterial &&
// //               item.materialEmpresa.codimate === codimate
// //           )
// //         : itensCarrinho.itens.findIndex(
// //             (item) =>
// //               item.idCatalogo === idCatalogo &&
// //               item.idPagina === idPagina &&
// //               item.idItem === idItem &&
// //               item.idMaterial === idMaterial
// //           );

// //       if (itemIndex >= 0) {
// //         const quantidadeTotal =
// //           itensCarrinho.itens[itemIndex].quantidadeTotal - quantidade;

// //         dispatch(
// //           atualizaQuantidadeRequest(
// //             idCatalogo,
// //             idPagina,
// //             idItem,
// //             idMaterial,
// //             quantidadeTotal,
// //             codimate
// //           )
// //         );
// //       }
// //     },
// //     [itensCarrinho, dispatch]
// //   );

// //   const handleSelecionado = useCallback(
// //     ({ value }, idCatalogo, idPagina, idItem, idMaterial, materialEmpresa) => {
// //       const codimate = materialEmpresa ? materialEmpresa.codimate : null;

// //       dispatch(
// //         atualizaItemOSRequest(
// //           idCatalogo,
// //           idPagina,
// //           idItem,
// //           idMaterial,
// //           value,
// //           codimate
// //         )
// //       );
// //     },
// //     [dispatch]
// //   );

// //   const handleExportar = useCallback(() => {
// //     const data = itensCarrinho.itens.map((item) => {
// //       const {
// //         materialEmpresa,
// //         partnumber,
// //         descricao,
// //         especTecnica,
// //         modelo,
// //         fabricante: { descricao: fabricante },
// //         quantidade,
// //         quantidadeTotal,
// //         paginaCatalogo: {
// //           descricao: pagina,
// //           catalogo: { nome: catalogo, versao },
// //         },
// //       } = item;

// //       const {
// //         codimate: codimateERP = null,
// //         descricao: descricaoERP = null,
// //         unidade: unidadeERP = null,
// //       } = materialEmpresa || {};

// //       return [
// //         codimateERP,
// //         descricaoERP,
// //         unidadeERP,
// //         partnumber,
// //         descricao,
// //         especTecnica,
// //         modelo,
// //         fabricante,
// //         quantidade,
// //         quantidadeTotal,
// //         pagina,
// //         catalogo,
// //         versao,
// //       ];
// //     });

// //     const fields = [
// //       'Código Material (ERP)',
// //       'Descrição (ERP)',
// //       'Unidade (ERP)',
// //       'Partnumber',
// //       'Descrição',
// //       'Espec. Técnica',
// //       'Modelo',
// //       'Fabricante',
// //       'Quantidade Catálogo',
// //       'Quantidade Solicitada',
// //       'Página',
// //       'Catálogo',
// //       'Versão',
// //     ];

// //     const csv = toCSV(fields, data);

// //     try {
// //       /** cria um link para o processo de download */
// //       const link = document.createElement('a');
// //       const file = `data:text/csv;charset=utf-8,%EF%BB%BF${encodeURI(csv)}`;

// //       link.href = file;
// //       link.download = `catalogo-eletronico-carrinho.csv`;

// //       document.body.appendChild(link);
// //       link.click();

// //       document.body.removeChild(link);
// //     } catch (err) {
// //       AppError(err);
// //     }
// //   }, [itensCarrinho]);

// //   const handleEmail = useCallback(
// //     async (paraEmpresa = false, emailData = null) => {
// //       const data = itensCarrinho.itens.map((item) => {
// //         const {
// //           materialEmpresa,
// //           partnumber,
// //           descricao,
// //           especTecnica,
// //           modelo,
// //           fabricante: { descricao: fabricante },
// //           quantidade,
// //           quantidadeTotal,
// //           paginaCatalogo: {
// //             descricao: pagina,
// //             catalogo: { nome: catalogo, versao },
// //           },
// //         } = item;

// //         const {
// //           codimate: codimateERP = null,
// //           descricao: descricaoERP = null,
// //           unidade: unidadeERP = null,
// //         } = materialEmpresa || {};

// //         return [
// //           codimateERP,
// //           descricaoERP,
// //           unidadeERP,
// //           partnumber,
// //           descricao,
// //           especTecnica,
// //           modelo,
// //           fabricante,
// //           quantidade,
// //           quantidadeTotal,
// //           pagina,
// //           catalogo,
// //           versao,
// //         ];
// //       });

// //       const fields = [
// //         'Código Material (ERP)',
// //         'Descrição (ERP)',
// //         'Unidade (ERP)',
// //         'Partnumber',
// //         'Descrição',
// //         'Espec. Técnica',
// //         'Modelo',
// //         'Fabricante',
// //         'Quantidade Catálogo',
// //         'Quantidade Solicitada',
// //         'Página',
// //         'Catálogo',
// //         'Versão',
// //       ];

// //       try {
// //         const csv = toCSV(fields, data);
// //         const blobFile = new Blob([`\uFEFF${csv}`], {
// //           type: 'text/csv;charset=utf-8;',
// //         });

// //         /** verifica parâmetro para envio de e-mail pelo servidor ou serviço próprio */
// //         if (sendServerEmail()) {
// //           history.push('/enviar-email', {
// //             background: location,
// //             tipo: emailTipo.EMAIL_CARRINHO,
// //             paraEmpresa,
// //             data: { attachment: blobFile, emailData },
// //           });
// //         } else {
// //           const formData = new FormData();
// //           formData.append('file', blobFile);

// //           const response = await api.post('email', formData);
// //           const { path } = response.data;

// //           const subject = encodeURIComponent(
// //             `Catálogo Eletrônico - Lista de Compras`
// //           );
// //           const body = encodeURIComponent(
// //             `Olá,\n\nSegue link para download da lista de compras:\n${path}\n\nAssiste - Catálogo Eletrônico`
// //           );

// //           /** cria um link para o processo de download */
// //           const link = document.createElement('a');
// //           link.href = `mailto:nome@endereco.com?subject=${subject}&body=${body}`;

// //           document.body.appendChild(link);
// //           link.click();

// //           document.body.removeChild(link);
// //         }
// //       } catch (err) {
// //         AppError(err);
// //       }
// //     },
// //     [location, itensCarrinho]
// //   );

// //   // const handleWhatsApp = useCallback(
// //   //   () => async (paraEmpresa = false) => {
// //   //     const data = itensCarrinho.itens.map((item) => {
// //   //       const {
// //   //         materialEmpresa,
// //   //         partnumber,
// //   //         descricao,
// //   //         especTecnica,
// //   //         modelo,
// //   //         fabricante: { descricao: fabricante },
// //   //         quantidade,
// //   //         quantidadeTotal,
// //   //         paginaCatalogo: {
// //   //           descricao: pagina,
// //   //           catalogo: { nome: catalogo, versao },
// //   //         },
// //   //       } = item;

// //   //       const {
// //   //         codimate: codimateERP = null,
// //   //         descricao: descricaoERP = null,
// //   //         unidade: unidadeERP = null,
// //   //       } = materialEmpresa || {};

// //   //       return [
// //   //         codimateERP,
// //   //         descricaoERP,
// //   //         unidadeERP,
// //   //         partnumber,
// //   //         descricao,
// //   //         especTecnica,
// //   //         modelo,
// //   //         fabricante,
// //   //         quantidade,
// //   //         quantidadeTotal,
// //   //         pagina,
// //   //         catalogo,
// //   //         versao,
// //   //       ];
// //   //     });

// //   //     const fields = [
// //   //       'Código Material (ERP)',
// //   //       'Descrição (ERP)',
// //   //       'Unidade (ERP)',
// //   //       'Partnumber',
// //   //       'Descrição',
// //   //       'Espec. Técnica',
// //   //       'Modelo',
// //   //       'Fabricante',
// //   //       'Quantidade Catálogo',
// //   //       'Quantidade Solicitada',
// //   //       'Página',
// //   //       'Catálogo',
// //   //       'Versão',
// //   //     ];

// //   //     try {
// //   //       const csv = toCSV(fields, data);
// //   //       const blobFile = new Blob([`\uFEFF${csv}`], {
// //   //         type: 'text/csv;charset=utf-8;',
// //   //       });

// //   //       /** verifica parâmetro para envio de e-mail pelo servidor ou serviço próprio */
// //   //       if (sendServerWhatsApp()) {
// //   //         history.push('/whatsapp', {
// //   //           background: location,
// //   //           tipo: whatsAppTipo.WHATSAPP_CARRINHO,
// //   //           paraEmpresa,
// //   //           data: { attachment: blobFile },
// //   //         });
// //   //       } else {
// //   //         const formData = new FormData();
// //   //         formData.append('file', blobFile);

// //   //         const response = await api.post('email', formData);
// //   //         const { path } = response.data;

// //   //         const subject = encodeURIComponent(
// //   //           `Catálogo Eletrônico - Lista de Compras`
// //   //         );
// //   //         const body = encodeURIComponent(
// //   //           `Olá,\n\nSegue link para download da lista de compras:\n${path}\n\nAssiste - Catálogo Eletrônico`
// //   //         );

// //   //         /** cria um link para o processo de download */
// //   //         const link = document.createElement('a');
// //   //         link.href = `mailto:nome@endereco.com?subject=${subject}&body=${body}`;

// //   //         document.body.appendChild(link);
// //   //         link.click();

// //   //         document.body.removeChild(link);
// //   //       }
// //   //     } catch (err) {
// //   //       AppError(err);
// //   //     }
// //   //   },
// //   //   [location, itensCarrinho]
// //   // );

// //   const handleConfirmar = useCallback(async () => {
// //     /** solicitação por token */
// //     if (action === opTipoAcao.INTEGRACAO_TOKEN) {
// //       handleEmail(true);
// //       return;
// //     }

// //     if (enviaEmailSolicitacao()) {
// //       const { adm, email, empresa, login, name, userId } = selectUser.profile;
// //       const { descricao, email: emailEmpresa, idEmpresa, url } = empresa;

// //       const emailData = {
// //         adm,
// //         email,
// //         empresa,
// //         login,
// //         name,
// //         userId,
// //         descricao,
// //         emailEmpresa,
// //         idEmpresa,
// //         url,
// //       };

// //       /**
// //        * CHAMAR A TELA DE ENVIO DE E-MAIL IGUAL ESTA EM
// //        * EXPORTAR LISTA DE COMPRAS > ENVIAR E
// //        */

// //       handleEmail({ paraEmpresa: false, emailData });
// //       return;
// //     }

// //     try {
// //       const {
// //         extCodiDiv2,
// //         extNumeOS,
// //         extObservacao,
// //         extUsuario,
// //         extExtra01,
// //         extExtra02,
// //         extExtra03,
// //         extExtra04,
// //       } = itensCarrinho;

// //       const response = await api.post('/solicitacao', {
// //         extCodiDiv2,
// //         extNumeOS,
// //         extObservacao,
// //         extUsuario,
// //         extExtra01,
// //         extExtra02,
// //         extExtra03,
// //         extExtra04,
// //         itensCarrinho: itensCarrinho.itens,
// //       });

// //       const { idSolicitacao } = response.data;

// //       /** limpa itens do carrinho */
// //       dispatch(limpaCarrinho());

// //       /** redireciona para página de solicitação */
// //       history.push('/checkout', { id: idSolicitacao });
// //     } catch (err) {
// //       AppError(err);
// //     }
// //   }, [dispatch, itensCarrinho, action, handleEmail]);

// //   /** sincroniza rótulos */
// //   const rotuloExtExtra01 = useMemo(() => labelExtExtra01(), []);
// //   const rotuloExtExtra02 = useMemo(() => labelExtExtra02(), []);
// //   const rotuloExtExtra03 = useMemo(() => labelExtExtra03(), []);
// //   const rotuloExtExtra04 = useMemo(() => labelExtExtra04(), []);

// //   const redirectToPage = useCallback((idCatalogo, idPagina) => {
// //     api
// //       .get(`/catalogo/${idCatalogo}/nivel-classificacao/pagina/${idPagina}`)
// //       .then((response) => {
// //         const { data } = response;

// //         const {
// //           idNivel,
// //           relacNivel: { nivel },
// //         } = data;

// //         history.push(
// //           `/catalogo.partes/${idCatalogo}?IDN_${nivel}=${idNivel}&IDP=${idPagina}`
// //         );
// //       })
// //       .catch((erro) => {
// //         console.error(erro);
// //       });
// //   }, []);

// //   return (
// //     <Container>
// //       <TitleBar back title={SELECTED_MATERIALS[idioma]} width={950} />
// //       <Wrapper>
// //         {itensCarrinho.itens.length > 0 ? (
// //           <Form initialData={itensCarrinho} onSubmit={handleConfirmar}>
// //             <Cart.Header>
// //               <Cart.HeaderTitle>
// //                 <strong>{YOUR_REQUEST[idioma]}</strong>
// //                 <span>{REVIEW_ITEMS_BEFORE_SUBMITTING[idioma]}</span>
// //               </Cart.HeaderTitle>
// //               <Cart.HeaderMeta>
// //                 <Cart.Count>
// //                   {itensCarrinho.itens.length}{' '}
// //                   {itensCarrinho.itens.length === 1
// //                     ? ITEM[idioma]
// //                     : ITEMS[idioma]}
// //                 </Cart.Count>
// //                 {/* <Cart.Tag>Sem valores</Cart.Tag> */}
// //               </Cart.HeaderMeta>
// //             </Cart.Header>

// //             <Table>
// //               <thead>
// //                 <tr>
// //                   <th> </th>
// //                   <th>Partnumber</th>
// //                   <th>Descrição</th>
// //                   <th>Quantidade</th>
// //                   <th> </th>
// //                 </tr>
// //               </thead>
// //               <tbody>
// //                 {itensCarrinho.itens.map((item, index) => (
// //                   <RowMaster key={index} noCursoPointer>
// //                     <td>
// //                       <Wrapper.BtnImg
// //                         onClick={() =>
// //                           redirectToPage(item.idCatalogo, item.idPagina)
// //                         }
// //                       >
// //                         <Cart.ItemNo>{index + 1}</Cart.ItemNo>
// //                         <img src={item.imagemCatalogo} alt="Imagem catálogo" />
// //                       </Wrapper.BtnImg>
// //                     </td>
// //                     <td>
// //                       <strong>{item.partnumber}</strong>
// //                     </td>
// //                     <td>
// //                       <Table.Description>
// //                         <strong>{item.descricao}</strong>
// //                         <span>{`${MODEL[idioma]}: ${item.modelo}`}</span>
// //                         <span>{`${MANUFACTURER[idioma]}: ${item.fabricante.descricao}`}</span>
// //                         {/* <span>{`Fabricante: ${item.materialFabricante.descricao}`}</span> */}
// //                         {/* <span>{`Fabricante: ${item.materialEmpresa}`}</span> */}
// //                         {item.materialEmpresa ? (
// //                           <>
// //                             <span>{`Código ERP: ${item.materialEmpresa.codimate}`}</span>
// //                             {item.materialEmpresa.paralelo === '1' && (
// //                               <Table.Error>
// //                                 Atenção: O material selecionado está cadastrado
// //                                 como não original
// //                               </Table.Error>
// //                             )}
// //                           </>
// //                         ) : (
// //                           <Table.Error>
// //                             {NO_ERP_CODE_RELATED_TO_MATERIAL[idioma]}
// //                           </Table.Error>
// //                         )}

// //                         {!criaItemOSSisma() && itensCarrinho.extNumeOS && (
// //                           <Scope path={`extItensOS[${index}]`}>
// //                             <InputViewer
// //                               id="itemKey"
// //                               name="itemKey"
// //                               defaultValue={index}
// //                               isHidden
// //                             />
// //                             <Table.Combo>
// //                               Item O.S.:
// //                               <Select
// //                                 id="itemValue"
// //                                 name="itemValue"
// //                                 options={item.itemOSFormatado}
// //                                 isSearchable
// //                                 defaultValue={
// //                                   item.itemOS
// //                                     ? item.itemOSFormatado.filter(
// //                                         (i) => i.value === item.itemOS
// //                                       )
// //                                     : item.itemOSFormatado[0]
// //                                 }
// //                                 width={300}
// //                                 onChange={(select) =>
// //                                   handleSelecionado(
// //                                     select,
// //                                     item.idCatalogo,
// //                                     item.idPagina,
// //                                     item.idItem,
// //                                     item.idMaterial,
// //                                     item.materialEmpresa
// //                                   )
// //                                 }
// //                               />
// //                             </Table.Combo>
// //                           </Scope>
// //                         )}
// //                         {criaItemOSSisma() && (
// //                           <>
// //                             {(usaMotivoFalha() ||
// //                               usaAgenteCausa() ||
// //                               usaSecaoTrab()) && (
// //                               <WrapperItemOS>
// //                                 <ItemOSTitle>Criação Item OS:</ItemOSTitle>
// //                                 <WrapperTableItemOS>
// //                                   <ItemOSTableLabel>
// //                                     {usaMotivoFalha() && (
// //                                       <span>Agente Causa: </span>
// //                                     )}
// //                                     {usaAgenteCausa() && (
// //                                       <span>Motivo Falha: </span>
// //                                     )}
// //                                     {usaSecaoTrab() && (
// //                                       <span>Seção Trabalho: </span>
// //                                     )}
// //                                   </ItemOSTableLabel>
// //                                   <ItemOSTableContent>
// //                                     {usaMotivoFalha() && (
// //                                       <p>
// //                                         <span>
// //                                           {item.agenteCausa.codiAgente} -{' '}
// //                                         </span>
// //                                         <span>
// //                                           {item.agenteCausa.descricao}
// //                                         </span>
// //                                       </p>
// //                                     )}
// //                                     {usaAgenteCausa() && (
// //                                       <p>
// //                                         <span>
// //                                           {item.motivoFalha.codiMofa} -{' '}
// //                                         </span>
// //                                         <span>
// //                                           {item.motivoFalha.descricao}
// //                                         </span>
// //                                       </p>
// //                                     )}
// //                                     {usaSecaoTrab() && (
// //                                       <p>
// //                                         <span>
// //                                           {item.secaoTrab.codiSetr} -{' '}
// //                                         </span>
// //                                         <span>{item.secaoTrab.descrResum}</span>
// //                                       </p>
// //                                     )}
// //                                   </ItemOSTableContent>
// //                                 </WrapperTableItemOS>
// //                               </WrapperItemOS>
// //                             )}
// //                             <WrapperItemOS>
// //                               <ItemOSTitle>Composição:</ItemOSTitle>
// //                               <WrapperTableItemOS>
// //                                 <ItemOSTableLabel>
// //                                   <span>Sistema: </span>
// //                                   <span>Local: </span>
// //                                 </ItemOSTableLabel>
// //                                 <ItemOSTableContent>
// //                                   <p>
// //                                     <span>{item.sistema.codiSist} - </span>
// //                                     <span>{item.sistema.descricao}</span>
// //                                   </p>
// //                                   <p>
// //                                     <span>{item.local.codiLoca} - </span>
// //                                     <span>{item.local.descricao}</span>
// //                                   </p>
// //                                 </ItemOSTableContent>
// //                               </WrapperTableItemOS>
// //                             </WrapperItemOS>
// //                           </>
// //                         )}
// //                       </Table.Description>
// //                     </td>
// //                     <td>
// //                       <strong>
// //                         <Table.Quantity>
// //                           <button
// //                             type="button"
// //                             onClick={() =>
// //                               handleRemover(
// //                                 item.idCatalogo,
// //                                 item.idPagina,
// //                                 item.idItem,
// //                                 item.idMaterial,
// //                                 item.materialEmpresa
// //                               )
// //                             }
// //                           >
// //                             <MdChevronLeft size={25} />
// //                           </button>
// //                           <span>{item.quantidadeTotal}</span>
// //                           <button
// //                             type="button"
// //                             onClick={() =>
// //                               handleAdicionar(
// //                                 item.idCatalogo,
// //                                 item.idPagina,
// //                                 item.idItem,
// //                                 item.idMaterial,
// //                                 item.materialEmpresa
// //                               )
// //                             }
// //                           >
// //                             <MdChevronRight size={25} />
// //                           </button>
// //                         </Table.Quantity>
// //                       </strong>
// //                     </td>
// //                     <td>
// //                       <Table.Action>
// //                         <Table.BtnRemove
// //                           type="button"
// //                           onClick={() =>
// //                             handleExcluir(
// //                               item.idCatalogo,
// //                               item.idPagina,
// //                               item.idItem,
// //                               item.idMaterial,
// //                               item.materialEmpresa
// //                             )
// //                           }
// //                         >
// //                           <MdDelete size={25} />
// //                         </Table.BtnRemove>
// //                       </Table.Action>
// //                     </td>
// //                   </RowMaster>
// //                 ))}
// //               </tbody>
// //             </Table>

// //             <Section>
// //               <Form.Title>{OTHER_INFORMATION[idioma]}</Form.Title>
// //               <Form.Column>
// //                 <Form.Row>
// //                   <InputViewer
// //                     id="nome"
// //                     name="nome"
// //                     label={`${REQUESTER[idioma]}:`}
// //                     asRow
// //                   />
// //                 </Form.Row>
// //                 {itensCarrinho.extNumeOS && (
// //                   <>
// //                     <InputViewer id="extCodiDiv2" name="extCodiDiv2" isHidden />
// //                     <Form.Row>
// //                       <InputViewer
// //                         id="extNumeOS"
// //                         name="extNumeOS"
// //                         label="Nº OS:"
// //                         asRow
// //                       />
// //                     </Form.Row>
// //                   </>
// //                 )}
// //                 {itensCarrinho.extUsuario && (
// //                   <Form.Row>
// //                     <InputViewer
// //                       id="extUsuario"
// //                       name="extUsuario"
// //                       label="Usuário:"
// //                       asRow
// //                     />
// //                   </Form.Row>
// //                 )}
// //                 {itensCarrinho.extExtra01 && (
// //                   <Form.Row>
// //                     <InputViewer
// //                       id="extExtra01"
// //                       name="extExtra01"
// //                       label={rotuloExtExtra01}
// //                       asRow
// //                     />
// //                   </Form.Row>
// //                 )}
// //                 {itensCarrinho.extExtra02 && (
// //                   <Form.Row>
// //                     <InputViewer
// //                       id="extExtra02"
// //                       name="extExtra02"
// //                       label={rotuloExtExtra02}
// //                       asRow
// //                     />
// //                   </Form.Row>
// //                 )}
// //                 {itensCarrinho.extExtra03 && (
// //                   <Form.Row>
// //                     <InputViewer
// //                       id="extExtra03"
// //                       name="extExtra03"
// //                       label={rotuloExtExtra03}
// //                       asRow
// //                     />
// //                   </Form.Row>
// //                 )}
// //                 {itensCarrinho.extExtra04 && (
// //                   <Form.Row>
// //                     <InputViewer
// //                       id="extExtra04"
// //                       name="extExtra04"
// //                       label={rotuloExtExtra04}
// //                       asRow
// //                     />
// //                   </Form.Row>
// //                 )}
// //                 {itensCarrinho.extObservacao && (
// //                   <Form.Row>
// //                     <InputViewer
// //                       id="extObservacao"
// //                       name="extObservacao"
// //                       type="textarea"
// //                     />
// //                   </Form.Row>
// //                 )}
// //               </Form.Column>
// //             </Section>

// //             <Footer>
// //               <ActionMenu
// //                 Icon={EXPORT_SHOPPING_LIST[idioma]}
// //                 onExportCSV={handleExportar}
// //                 onMail={!enviaEmailSolicitacao() && handleEmail}
// //                 // onWhatsApp={handleWhatsApp}
// //               />

// //               <Footer.Actions>
// //                 <Footer.Count>
// //                   {itensCarrinho.itens.length}{' '}
// //                   {itensCarrinho.itens.length === 1
// //                     ? ITEM[idioma]
// //                     : ITEMS[idioma]}
// //                 </Footer.Count>

// //                 {utilizaSolicitarPecas() &&
// //                   (!app || action === opTipoAcao.INTEGRACAO_CATALOGO) && (
// //                     <Footer.Submit type="submit">
// //                       {action === opTipoAcao.INTEGRACAO_TOKEN
// //                         ? REQUEST_QUOTE[idioma]
// //                         : REQUEST_PARTS[idioma]}
// //                     </Footer.Submit>
// //                   )}
// //               </Footer.Actions>

// //               {/* {(!app || action === opTipoAcao.INTEGRACAO_CATALOGO) && (
// //                 <Footer.Submit type="submit">
// //                   {action === opTipoAcao.INTEGRACAO_TOKEN
// //                     ? 'Solicitar Orçamento'
// //                     : 'Solicitar Peças'}
// //                 </Footer.Submit>
// //               )} */}
// //             </Footer>
// //           </Form>
// //         ) : (
// //           <Wrapper.NotFound>
// //             <MdShoppingCart size={46} />
// //             <strong>{NO_ITEM_ADDED_TO_CART[idioma]}</strong>
// //             <span>{BROWSE_CATALOG_AND_ADD_PARTS[idioma]}</span>
// //             <Wrapper.BackButton type="button" onClick={() => history.push('/')}>
// //               <MdArrowBack size={18} />
// //               {BACK_TO_CATALOG[idioma]}
// //             </Wrapper.BackButton>
// //           </Wrapper.NotFound>
// //         )}
// //       </Wrapper>
// //     </Container>
// //   );
// // }

// // export default Carrinho;

// import React, { useCallback, useMemo } from 'react';
// import { useLocation } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';
// import { Scope } from '@unform/core';
// import {
//   MdDelete,
//   MdChevronLeft,
//   MdChevronRight,
//   MdShoppingCart,
//   MdArrowBack,
// } from 'react-icons/md';

// import { toast } from 'react-toastify';
// import { AppError } from '../../../errors/AppError';

// import {
//   atualizaQuantidadeRequest,
//   atualizaItemOSRequest,
//   removeCarrinho,
//   limpaCarrinho,
// } from '../../../store/modules/cart/actions';

// import history from '../../../services/history';
// import api from '../../../services/api';

// import { opTipoAcao } from '../../../lib/const';
// import {
//   sendServerEmail,
//   // sendServerWhatsApp,
//   labelExtExtra01,
//   labelExtExtra02,
//   labelExtExtra03,
//   labelExtExtra04,
//   criaItemOSSisma,
//   enviaEmailSolicitacao,
//   usaMotivoFalha,
//   usaAgenteCausa,
//   usaSecaoTrab,
//   utilizaSolicitarPecas,
// } from '../../../lib/paramUtils';
// import { toCSV } from '../../../lib/csv-core';

// import ActionMenu from '../../../components/ActionMenu';

// import TitleBar from '../../../components/TitleBar';

// import { Form } from '../../../components/Form';
// import InputViewer from '../../../components/Form/Input/Viewer';
// import Select from '../../../components/Form/Input/Select';

// import { RowMaster } from '../../../components/Table';

// import { emailTipo } from '../../Usuario/_usuario-email';

// import {
//   Container,
//   Cart,
//   Wrapper,
//   Section,
//   Table,
//   Footer,
//   WrapperItemOS,
//   ItemOSTitle,
//   ItemOSLabel,
//   ItemOSTableLabel,
//   ItemOSTableContent,
//   WrapperTableItemOS,
// } from './styles';
// import {
//   BACK_TO_CATALOG,
//   BROWSE_CATALOG_AND_ADD_PARTS,
//   EXPORT_SHOPPING_LIST,
//   ITEM,
//   ITEMS,
//   MANUFACTURER,
//   MODEL,
//   NO_ERP_CODE_RELATED_TO_MATERIAL,
//   NO_ITEM_ADDED_TO_CART,
//   opIdiomaCatalogo,
//   OTHER_INFORMATION,
//   REQUEST_PARTS,
//   REQUEST_QUOTE,
//   REQUESTER,
//   REVIEW_ITEMS_BEFORE_SUBMITTING,
//   SELECTED_MATERIALS,
//   YOUR_REQUEST,
// } from '../../../lib/idiomaAppOptions';
// // import { whatsAppTipo } from '../../WhatsApp';

// function Carrinho() {
//   const location = useLocation();
//   const dispatch = useDispatch();

//   const selectUser = useSelector((state) => state.user);

//   const profile = useSelector((state) => {
//     const { userId, name = '', adm, empresa } = state.user.profile || {};
//     const { idEmpresa, url: logotipo } = empresa || {};

//     return { userId, name, adm, idEmpresa, url: logotipo };
//   });

//   const carrinho = useSelector((state) =>
//     state.cart.items.map((item) => ({
//       ...item,
//       ...item.materialFabricante,
//     }))
//   );

//   /** idioma do catálogo escolhido pelo usuário (null = padrão) */
//   const idiomaCatalogo = useSelector(
//     (state) => state.param.idiomaCatalogo || null
//   );

//   /** e-mail do deep-link SSO (destinatário do orçamento/solicitação) */
//   const ssoQuoteEmail = useSelector(
//     (state) => (state.param.sso && state.param.sso.quoteEmail) || null
//   );

//   const idioma = idiomaCatalogo || opIdiomaCatalogo.BR;

//   const itensCarrinho = useSelector((state) => {
//     const { cart, user } = state;

//     /** dados do carrinho */
//     const {
//       items,
//       order: {
//         extCodiDiv2,
//         extNumeOS,
//         extItemOS,
//         extObservacao,
//         extUsuario,
//         extExtra01,
//         extExtra02,
//         extExtra03,
//         extExtra04,
//       },
//     } = cart;

//     /** dados do usuário */
//     const { profile } = user || {};
//     const { name = '' } = profile || {};

//     /** percorre todos os itens do carrinho */
//     const itens = items.map((item) => {
//       const {
//         materialFabricante,
//         paginaCatalogo,
//         itemOS,
//         partnumber,
//         ...itemRestante
//       } = item;

//       const {
//         catalogo: { modelo },
//       } = paginaCatalogo;

//       // extItemOS.push('0 - Inserir Item Novo na OS');

//       return {
//         ...itemRestante,
//         ...materialFabricante,
//         itemOS,
//         itemOSFormatado: extItemOS.map((sequencia) => ({
//           value: sequencia.value,
//           label: sequencia.label,
//         })),
//         paginaCatalogo,
//         modelo: modelo.map((m) => m.descricao).join(', '),
//         partnumber,
//       };
//     });

//     const extObservacaoFormatada = extObservacao || '';

//     return {
//       extCodiDiv2,
//       extNumeOS,
//       extObservacao: extObservacaoFormatada.split('$n').join('\r\n'),
//       extUsuario,
//       extExtra01,
//       extExtra02,
//       extExtra03,
//       extExtra04,
//       nome: name,
//       itens,
//     };
//   });

//   const { app, action } = useSelector((state) => state.auth || {});

//   const handleExcluir = useCallback(
//     (idCatalogo, idPagina, idItem, idMaterial, materialEmpresa) => {
//       const codimate = materialEmpresa ? materialEmpresa.codimate : null;

//       dispatch(
//         removeCarrinho(idCatalogo, idPagina, idItem, idMaterial, codimate)
//       );
//     },
//     [dispatch]
//   );

//   const handleAdicionar = useCallback(
//     (
//       idCatalogo,
//       idPagina,
//       idItem,
//       idMaterial,
//       materialEmpresa,
//       quantidade = 1
//     ) => {
//       const codimate = materialEmpresa ? materialEmpresa.codimate : null;

//       const itemIndex = codimate
//         ? itensCarrinho.itens.findIndex(
//             (item) =>
//               item.idCatalogo === idCatalogo &&
//               item.idPagina === idPagina &&
//               item.idItem === idItem &&
//               item.idMaterial === idMaterial &&
//               item.materialEmpresa.codimate === codimate
//           )
//         : itensCarrinho.itens.findIndex(
//             (item) =>
//               item.idCatalogo === idCatalogo &&
//               item.idPagina === idPagina &&
//               item.idItem === idItem &&
//               item.idMaterial === idMaterial
//           );

//       if (itemIndex >= 0) {
//         const quantidadeTotal =
//           itensCarrinho.itens[itemIndex].quantidadeTotal + quantidade;

//         dispatch(
//           atualizaQuantidadeRequest(
//             idCatalogo,
//             idPagina,
//             idItem,
//             idMaterial,
//             quantidadeTotal,
//             codimate
//           )
//         );
//       }
//     },
//     [itensCarrinho, dispatch]
//   );

//   const handleRemover = useCallback(
//     (
//       idCatalogo,
//       idPagina,
//       idItem,
//       idMaterial,
//       materialEmpresa,
//       quantidade = 1
//     ) => {
//       const codimate = materialEmpresa ? materialEmpresa.codimate : null;

//       const itemIndex = codimate
//         ? itensCarrinho.itens.findIndex(
//             (item) =>
//               item.idCatalogo === idCatalogo &&
//               item.idPagina === idPagina &&
//               item.idItem === idItem &&
//               item.idMaterial === idMaterial &&
//               item.materialEmpresa.codimate === codimate
//           )
//         : itensCarrinho.itens.findIndex(
//             (item) =>
//               item.idCatalogo === idCatalogo &&
//               item.idPagina === idPagina &&
//               item.idItem === idItem &&
//               item.idMaterial === idMaterial
//           );

//       if (itemIndex >= 0) {
//         const quantidadeTotal =
//           itensCarrinho.itens[itemIndex].quantidadeTotal - quantidade;

//         dispatch(
//           atualizaQuantidadeRequest(
//             idCatalogo,
//             idPagina,
//             idItem,
//             idMaterial,
//             quantidadeTotal,
//             codimate
//           )
//         );
//       }
//     },
//     [itensCarrinho, dispatch]
//   );

//   const handleSelecionado = useCallback(
//     ({ value }, idCatalogo, idPagina, idItem, idMaterial, materialEmpresa) => {
//       const codimate = materialEmpresa ? materialEmpresa.codimate : null;

//       dispatch(
//         atualizaItemOSRequest(
//           idCatalogo,
//           idPagina,
//           idItem,
//           idMaterial,
//           value,
//           codimate
//         )
//       );
//     },
//     [dispatch]
//   );

//   const handleExportar = useCallback(() => {
//     const data = itensCarrinho.itens.map((item) => {
//       const {
//         materialEmpresa,
//         partnumber,
//         descricao,
//         especTecnica,
//         modelo,
//         fabricante: { descricao: fabricante },
//         quantidade,
//         quantidadeTotal,
//         paginaCatalogo: {
//           descricao: pagina,
//           catalogo: { nome: catalogo, versao },
//         },
//       } = item;

//       const {
//         codimate: codimateERP = null,
//         descricao: descricaoERP = null,
//         unidade: unidadeERP = null,
//       } = materialEmpresa || {};

//       return [
//         codimateERP,
//         descricaoERP,
//         unidadeERP,
//         partnumber,
//         descricao,
//         especTecnica,
//         modelo,
//         fabricante,
//         quantidade,
//         quantidadeTotal,
//         pagina,
//         catalogo,
//         versao,
//       ];
//     });

//     const fields = [
//       'Código Material (ERP)',
//       'Descrição (ERP)',
//       'Unidade (ERP)',
//       'Partnumber',
//       'Descrição',
//       'Espec. Técnica',
//       'Modelo',
//       'Fabricante',
//       'Quantidade Catálogo',
//       'Quantidade Solicitada',
//       'Página',
//       'Catálogo',
//       'Versão',
//     ];

//     const csv = toCSV(fields, data);

//     try {
//       /** cria um link para o processo de download */
//       const link = document.createElement('a');
//       const file = `data:text/csv;charset=utf-8,%EF%BB%BF${encodeURI(csv)}`;

//       link.href = file;
//       link.download = `catalogo-eletronico-carrinho.csv`;

//       document.body.appendChild(link);
//       link.click();

//       document.body.removeChild(link);
//     } catch (err) {
//       AppError(err);
//     }
//   }, [itensCarrinho]);

//   const handleEmail = useCallback(
//     async (paraEmpresa = false, emailData = null) => {
//       const data = itensCarrinho.itens.map((item) => {
//         const {
//           materialEmpresa,
//           partnumber,
//           descricao,
//           especTecnica,
//           modelo,
//           fabricante: { descricao: fabricante },
//           quantidade,
//           quantidadeTotal,
//           paginaCatalogo: {
//             descricao: pagina,
//             catalogo: { nome: catalogo, versao },
//           },
//         } = item;

//         const {
//           codimate: codimateERP = null,
//           descricao: descricaoERP = null,
//           unidade: unidadeERP = null,
//         } = materialEmpresa || {};

//         return [
//           codimateERP,
//           descricaoERP,
//           unidadeERP,
//           partnumber,
//           descricao,
//           especTecnica,
//           modelo,
//           fabricante,
//           quantidade,
//           quantidadeTotal,
//           pagina,
//           catalogo,
//           versao,
//         ];
//       });

//       const fields = [
//         'Código Material (ERP)',
//         'Descrição (ERP)',
//         'Unidade (ERP)',
//         'Partnumber',
//         'Descrição',
//         'Espec. Técnica',
//         'Modelo',
//         'Fabricante',
//         'Quantidade Catálogo',
//         'Quantidade Solicitada',
//         'Página',
//         'Catálogo',
//         'Versão',
//       ];

//       try {
//         const csv = toCSV(fields, data);
//         const blobFile = new Blob([`\uFEFF${csv}`], {
//           type: 'text/csv;charset=utf-8;',
//         });

//         /** verifica parâmetro para envio de e-mail pelo servidor ou serviço próprio */
//         if (sendServerEmail()) {
//           history.push('/enviar-email', {
//             background: location,
//             tipo: emailTipo.EMAIL_CARRINHO,
//             paraEmpresa,
//             data: { attachment: blobFile, emailData },
//           });
//         } else {
//           const formData = new FormData();
//           formData.append('file', blobFile);

//           const response = await api.post('email', formData);
//           const { path } = response.data;

//           const subject = encodeURIComponent(
//             `Catálogo Eletrônico - Lista de Compras`
//           );
//           const body = encodeURIComponent(
//             `Olá,\n\nSegue link para download da lista de compras:\n${path}\n\nAssiste - Catálogo Eletrônico`
//           );

//           /** cria um link para o processo de download */
//           const link = document.createElement('a');
//           link.href = `mailto:${
//             ssoQuoteEmail || 'nome@endereco.com'
//           }?subject=${subject}&body=${body}`;

//           document.body.appendChild(link);
//           link.click();

//           document.body.removeChild(link);
//         }
//       } catch (err) {
//         AppError(err);
//       }
//     },
//     [location, itensCarrinho, ssoQuoteEmail]
//   );

//   // const handleWhatsApp = useCallback(
//   //   () => async (paraEmpresa = false) => {
//   //     const data = itensCarrinho.itens.map((item) => {
//   //       const {
//   //         materialEmpresa,
//   //         partnumber,
//   //         descricao,
//   //         especTecnica,
//   //         modelo,
//   //         fabricante: { descricao: fabricante },
//   //         quantidade,
//   //         quantidadeTotal,
//   //         paginaCatalogo: {
//   //           descricao: pagina,
//   //           catalogo: { nome: catalogo, versao },
//   //         },
//   //       } = item;

//   //       const {
//   //         codimate: codimateERP = null,
//   //         descricao: descricaoERP = null,
//   //         unidade: unidadeERP = null,
//   //       } = materialEmpresa || {};

//   //       return [
//   //         codimateERP,
//   //         descricaoERP,
//   //         unidadeERP,
//   //         partnumber,
//   //         descricao,
//   //         especTecnica,
//   //         modelo,
//   //         fabricante,
//   //         quantidade,
//   //         quantidadeTotal,
//   //         pagina,
//   //         catalogo,
//   //         versao,
//   //       ];
//   //     });

//   //     const fields = [
//   //       'Código Material (ERP)',
//   //       'Descrição (ERP)',
//   //       'Unidade (ERP)',
//   //       'Partnumber',
//   //       'Descrição',
//   //       'Espec. Técnica',
//   //       'Modelo',
//   //       'Fabricante',
//   //       'Quantidade Catálogo',
//   //       'Quantidade Solicitada',
//   //       'Página',
//   //       'Catálogo',
//   //       'Versão',
//   //     ];

//   //     try {
//   //       const csv = toCSV(fields, data);
//   //       const blobFile = new Blob([`\uFEFF${csv}`], {
//   //         type: 'text/csv;charset=utf-8;',
//   //       });

//   //       /** verifica parâmetro para envio de e-mail pelo servidor ou serviço próprio */
//   //       if (sendServerWhatsApp()) {
//   //         history.push('/whatsapp', {
//   //           background: location,
//   //           tipo: whatsAppTipo.WHATSAPP_CARRINHO,
//   //           paraEmpresa,
//   //           data: { attachment: blobFile },
//   //         });
//   //       } else {
//   //         const formData = new FormData();
//   //         formData.append('file', blobFile);

//   //         const response = await api.post('email', formData);
//   //         const { path } = response.data;

//   //         const subject = encodeURIComponent(
//   //           `Catálogo Eletrônico - Lista de Compras`
//   //         );
//   //         const body = encodeURIComponent(
//   //           `Olá,\n\nSegue link para download da lista de compras:\n${path}\n\nAssiste - Catálogo Eletrônico`
//   //         );

//   //         /** cria um link para o processo de download */
//   //         const link = document.createElement('a');
//   //         link.href = `mailto:nome@endereco.com?subject=${subject}&body=${body}`;

//   //         document.body.appendChild(link);
//   //         link.click();

//   //         document.body.removeChild(link);
//   //       }
//   //     } catch (err) {
//   //       AppError(err);
//   //     }
//   //   },
//   //   [location, itensCarrinho]
//   // );

//   const handleShared = useCallback(async () => {
//     navigator.vibrate(200);

//     const { userId, name, idEmpresa } = profile;

//     const obs = `Token de compartilhamento criado pelo usuário ${userId} - ${name}`;

//     const { idCatalogo } = itensCarrinho.itens[0];

//     const itemQtdForToken = carrinho.map((i) => {
//       const {
//         idItem,
//         quantidadeTotal,
//         idMaterial,
//         idPagina: idPag,
//         codimate,
//         imagemCatalogo,
//       } = i;

//       return `&IDPAG_${idItem}=${idPag}&IDI=${idItem}&IDMAT_${idItem}=${idMaterial}&CODMAT_${idItem}=${codimate}&QTD_${idItem}=${quantidadeTotal}&IMG_${idItem}=${imagemCatalogo}`;
//     });

//     const { data } = await api.post(
//       `empresa/${idEmpresa}/catalogo/${idCatalogo}/token-acesso`,
//       {
//         nome: 'Compartilhamento',
//         duracao: 3, // dias
//         observacao: obs,
//         tipo: 0,
//         info: itemQtdForToken,
//       }
//     );

//     if (!data) {
//       toast.error(
//         'Erro na geração do token de compartilhamento, tente novamente mais tarde!'
//       );
//     }

//     const { nanoId } = data; // token

//     const { pathname, search } = location;

//     // const locationShared = window.location.href.replaceAll(
//     //   `${pathname}${search}`,
//     //   `/catalogo-token?token=${token}`
//     // );

//     const locationSharedNanoId = window.location.href.replaceAll(
//       `${pathname}${search}`,
//       `/catalogo-token?ass=${nanoId}`
//     );

//     // const fmtLocationShared = locationShared.replaceAll(',', '');
//     const fmtLocationSharedNanoId = locationSharedNanoId.replaceAll(',', '');

//     // const urlShared = `${fmtLocationShared}${carrinho.map((i) => {
//     //   const { idItem, quantidadeTotal } = i;
//     //   return `&IDI=${idItem}&IT_${idItem}QTD=${quantidadeTotal}`;
//     // })}`;

//     // const fmtUrlShared = urlShared.replaceAll(',', '');

//     // setUrlShared(fmtLocationSharedNanoId);

//     if (navigator.canShare) {
//       try {
//         await navigator
//           .share({
//             title: 'CDI - Catálogo Digital Interativo',
//             text: 'Catálogo disponibilizado pela Assiste Engenharia',
//             url: fmtLocationSharedNanoId,
//           })
//           .then(() => console.log('Compartilhado com sucesso!'));
//       } catch (error) {
//         console.log(error);
//         toast.info('Volte para compartilhar quando desejar!');
//       }
//     } else {
//       alert('A API de compartilhamento não é suportada nesse browser.');
//     }
//   }, [carrinho, itensCarrinho, location, profile]);

//   const handleConfirmar = useCallback(async () => {
//     /** solicitação por token */
//     if (action === opTipoAcao.INTEGRACAO_TOKEN) {
//       handleEmail(true);
//       return;
//     }

//     if (enviaEmailSolicitacao()) {
//       const { adm, email, empresa, login, name, userId } = selectUser.profile;
//       const { descricao, email: emailEmpresa, idEmpresa, url } = empresa;

//       const emailData = {
//         adm,
//         email,
//         empresa,
//         login,
//         name,
//         userId,
//         descricao,
//         emailEmpresa,
//         idEmpresa,
//         url,
//       };

//       /**
//        * CHAMAR A TELA DE ENVIO DE E-MAIL IGUAL ESTA EM
//        * EXPORTAR LISTA DE COMPRAS > ENVIAR E
//        */

//       handleEmail({ paraEmpresa: false, emailData });
//       return;
//     }

//     try {
//       const {
//         extCodiDiv2,
//         extNumeOS,
//         extObservacao,
//         extUsuario,
//         extExtra01,
//         extExtra02,
//         extExtra03,
//         extExtra04,
//       } = itensCarrinho;

//       const response = await api.post('/solicitacao', {
//         extCodiDiv2,
//         extNumeOS,
//         extObservacao,
//         extUsuario,
//         extExtra01,
//         extExtra02,
//         extExtra03,
//         extExtra04,
//         itensCarrinho: itensCarrinho.itens,
//       });

//       const { idSolicitacao } = response.data;

//       /** limpa itens do carrinho */
//       dispatch(limpaCarrinho());

//       /** redireciona para página de solicitação */
//       history.push('/checkout', { id: idSolicitacao });
//     } catch (err) {
//       AppError(err);
//     }
//   }, [dispatch, itensCarrinho, action, handleEmail]);

//   /** sincroniza rótulos */
//   const rotuloExtExtra01 = useMemo(() => labelExtExtra01(), []);
//   const rotuloExtExtra02 = useMemo(() => labelExtExtra02(), []);
//   const rotuloExtExtra03 = useMemo(() => labelExtExtra03(), []);
//   const rotuloExtExtra04 = useMemo(() => labelExtExtra04(), []);

//   const redirectToPage = useCallback((idCatalogo, idPagina) => {
//     api
//       .get(`/catalogo/${idCatalogo}/nivel-classificacao/pagina/${idPagina}`)
//       .then((response) => {
//         const { data } = response;

//         const {
//           idNivel,
//           relacNivel: { nivel },
//         } = data;

//         history.push(
//           `/catalogo.partes/${idCatalogo}?IDN_${nivel}=${idNivel}&IDP=${idPagina}`
//         );
//       })
//       .catch((erro) => {
//         console.error(erro);
//       });
//   }, []);

//   return (
//     <Container>
//       <TitleBar back title={SELECTED_MATERIALS[idioma]} width={950} />
//       <Wrapper>
//         {itensCarrinho.itens.length > 0 ? (
//           <Form initialData={itensCarrinho} onSubmit={handleConfirmar}>
//             <Cart.Header>
//               <Cart.HeaderTitle>
//                 <strong>{YOUR_REQUEST[idioma]}</strong>
//                 <span>{REVIEW_ITEMS_BEFORE_SUBMITTING[idioma]}</span>
//               </Cart.HeaderTitle>
//               <Cart.HeaderMeta>
//                 <Cart.Count>
//                   {itensCarrinho.itens.length}{' '}
//                   {itensCarrinho.itens.length === 1
//                     ? ITEM[idioma]
//                     : ITEMS[idioma]}
//                 </Cart.Count>
//                 {/* <Cart.Tag>Sem valores</Cart.Tag> */}
//               </Cart.HeaderMeta>
//             </Cart.Header>

//             <Table>
//               <thead>
//                 <tr>
//                   <th> </th>
//                   <th>Partnumber</th>
//                   <th>Descrição</th>
//                   <th>Quantidade</th>
//                   <th> </th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {itensCarrinho.itens.map((item, index) => (
//                   <RowMaster key={index} noCursoPointer>
//                     <td>
//                       <Wrapper.BtnImg
//                         onClick={() =>
//                           redirectToPage(item.idCatalogo, item.idPagina)
//                         }
//                       >
//                         <Cart.ItemNo>{index + 1}</Cart.ItemNo>
//                         <img src={item.imagemCatalogo} alt="Imagem catálogo" />
//                       </Wrapper.BtnImg>
//                     </td>
//                     <td>
//                       <strong>{item.partnumber}</strong>
//                     </td>
//                     <td>
//                       <Table.Description>
//                         <strong>{item.descricao}</strong>
//                         <span>{`${MODEL[idioma]}: ${item.modelo}`}</span>
//                         <span>{`${MANUFACTURER[idioma]}: ${item.fabricante.descricao}`}</span>
//                         {/* <span>{`Fabricante: ${item.materialFabricante.descricao}`}</span> */}
//                         {/* <span>{`Fabricante: ${item.materialEmpresa}`}</span> */}
//                         {item.materialEmpresa ? (
//                           <>
//                             <span>{`Código ERP: ${item.materialEmpresa.codimate}`}</span>
//                             {item.materialEmpresa.paralelo === '1' && (
//                               <Table.Error>
//                                 Atenção: O material selecionado está cadastrado
//                                 como não original
//                               </Table.Error>
//                             )}
//                           </>
//                         ) : (
//                           <Table.Error>
//                             {NO_ERP_CODE_RELATED_TO_MATERIAL[idioma]}
//                           </Table.Error>
//                         )}

//                         {!criaItemOSSisma() && itensCarrinho.extNumeOS && (
//                           <Scope path={`extItensOS[${index}]`}>
//                             <InputViewer
//                               id="itemKey"
//                               name="itemKey"
//                               defaultValue={index}
//                               isHidden
//                             />
//                             <Table.Combo>
//                               Item O.S.:
//                               <Select
//                                 id="itemValue"
//                                 name="itemValue"
//                                 options={item.itemOSFormatado}
//                                 isSearchable
//                                 defaultValue={
//                                   item.itemOS
//                                     ? item.itemOSFormatado.filter(
//                                         (i) => i.value === item.itemOS
//                                       )
//                                     : item.itemOSFormatado[0]
//                                 }
//                                 width={300}
//                                 onChange={(select) =>
//                                   handleSelecionado(
//                                     select,
//                                     item.idCatalogo,
//                                     item.idPagina,
//                                     item.idItem,
//                                     item.idMaterial,
//                                     item.materialEmpresa
//                                   )
//                                 }
//                               />
//                             </Table.Combo>
//                           </Scope>
//                         )}
//                         {criaItemOSSisma() && (
//                           <>
//                             {(usaMotivoFalha() ||
//                               usaAgenteCausa() ||
//                               usaSecaoTrab()) && (
//                               <WrapperItemOS>
//                                 <ItemOSTitle>Criação Item OS:</ItemOSTitle>
//                                 <WrapperTableItemOS>
//                                   <ItemOSTableLabel>
//                                     {usaMotivoFalha() && (
//                                       <span>Agente Causa: </span>
//                                     )}
//                                     {usaAgenteCausa() && (
//                                       <span>Motivo Falha: </span>
//                                     )}
//                                     {usaSecaoTrab() && (
//                                       <span>Seção Trabalho: </span>
//                                     )}
//                                   </ItemOSTableLabel>
//                                   <ItemOSTableContent>
//                                     {usaMotivoFalha() && (
//                                       <p>
//                                         <span>
//                                           {item.agenteCausa.codiAgente} -{' '}
//                                         </span>
//                                         <span>
//                                           {item.agenteCausa.descricao}
//                                         </span>
//                                       </p>
//                                     )}
//                                     {usaAgenteCausa() && (
//                                       <p>
//                                         <span>
//                                           {item.motivoFalha.codiMofa} -{' '}
//                                         </span>
//                                         <span>
//                                           {item.motivoFalha.descricao}
//                                         </span>
//                                       </p>
//                                     )}
//                                     {usaSecaoTrab() && (
//                                       <p>
//                                         <span>
//                                           {item.secaoTrab.codiSetr} -{' '}
//                                         </span>
//                                         <span>{item.secaoTrab.descrResum}</span>
//                                       </p>
//                                     )}
//                                   </ItemOSTableContent>
//                                 </WrapperTableItemOS>
//                               </WrapperItemOS>
//                             )}
//                             <WrapperItemOS>
//                               <ItemOSTitle>Composição:</ItemOSTitle>
//                               <WrapperTableItemOS>
//                                 <ItemOSTableLabel>
//                                   <span>Sistema: </span>
//                                   <span>Local: </span>
//                                 </ItemOSTableLabel>
//                                 <ItemOSTableContent>
//                                   <p>
//                                     <span>{item.sistema.codiSist} - </span>
//                                     <span>{item.sistema.descricao}</span>
//                                   </p>
//                                   <p>
//                                     <span>{item.local.codiLoca} - </span>
//                                     <span>{item.local.descricao}</span>
//                                   </p>
//                                 </ItemOSTableContent>
//                               </WrapperTableItemOS>
//                             </WrapperItemOS>
//                           </>
//                         )}
//                       </Table.Description>
//                     </td>
//                     <td>
//                       <strong>
//                         <Table.Quantity>
//                           <button
//                             type="button"
//                             onClick={() =>
//                               handleRemover(
//                                 item.idCatalogo,
//                                 item.idPagina,
//                                 item.idItem,
//                                 item.idMaterial,
//                                 item.materialEmpresa
//                               )
//                             }
//                           >
//                             <MdChevronLeft size={25} />
//                           </button>
//                           <span>{item.quantidadeTotal}</span>
//                           <button
//                             type="button"
//                             onClick={() =>
//                               handleAdicionar(
//                                 item.idCatalogo,
//                                 item.idPagina,
//                                 item.idItem,
//                                 item.idMaterial,
//                                 item.materialEmpresa
//                               )
//                             }
//                           >
//                             <MdChevronRight size={25} />
//                           </button>
//                         </Table.Quantity>
//                       </strong>
//                     </td>
//                     <td>
//                       <Table.Action>
//                         <Table.BtnRemove
//                           type="button"
//                           onClick={() =>
//                             handleExcluir(
//                               item.idCatalogo,
//                               item.idPagina,
//                               item.idItem,
//                               item.idMaterial,
//                               item.materialEmpresa
//                             )
//                           }
//                         >
//                           <MdDelete size={25} />
//                         </Table.BtnRemove>
//                       </Table.Action>
//                     </td>
//                   </RowMaster>
//                 ))}
//               </tbody>
//             </Table>

//             <Section>
//               <Form.Title>{OTHER_INFORMATION[idioma]}</Form.Title>
//               <Form.Column>
//                 <Form.Row>
//                   <InputViewer
//                     id="nome"
//                     name="nome"
//                     label={`${REQUESTER[idioma]}:`}
//                     asRow
//                   />
//                 </Form.Row>
//                 {itensCarrinho.extNumeOS && (
//                   <>
//                     <InputViewer id="extCodiDiv2" name="extCodiDiv2" isHidden />
//                     <Form.Row>
//                       <InputViewer
//                         id="extNumeOS"
//                         name="extNumeOS"
//                         label="Nº OS:"
//                         asRow
//                       />
//                     </Form.Row>
//                   </>
//                 )}
//                 {itensCarrinho.extUsuario && (
//                   <Form.Row>
//                     <InputViewer
//                       id="extUsuario"
//                       name="extUsuario"
//                       label="Usuário:"
//                       asRow
//                     />
//                   </Form.Row>
//                 )}
//                 {itensCarrinho.extExtra01 && (
//                   <Form.Row>
//                     <InputViewer
//                       id="extExtra01"
//                       name="extExtra01"
//                       label={rotuloExtExtra01}
//                       asRow
//                     />
//                   </Form.Row>
//                 )}
//                 {itensCarrinho.extExtra02 && (
//                   <Form.Row>
//                     <InputViewer
//                       id="extExtra02"
//                       name="extExtra02"
//                       label={rotuloExtExtra02}
//                       asRow
//                     />
//                   </Form.Row>
//                 )}
//                 {itensCarrinho.extExtra03 && (
//                   <Form.Row>
//                     <InputViewer
//                       id="extExtra03"
//                       name="extExtra03"
//                       label={rotuloExtExtra03}
//                       asRow
//                     />
//                   </Form.Row>
//                 )}
//                 {itensCarrinho.extExtra04 && (
//                   <Form.Row>
//                     <InputViewer
//                       id="extExtra04"
//                       name="extExtra04"
//                       label={rotuloExtExtra04}
//                       asRow
//                     />
//                   </Form.Row>
//                 )}
//                 {itensCarrinho.extObservacao && (
//                   <Form.Row>
//                     <InputViewer
//                       id="extObservacao"
//                       name="extObservacao"
//                       type="textarea"
//                     />
//                   </Form.Row>
//                 )}
//               </Form.Column>
//             </Section>

//             <Footer>
//               <ActionMenu
//                 topContainer
//                 Icon={EXPORT_SHOPPING_LIST[idioma]}
//                 onExportCSV={handleExportar}
//                 onMail={!enviaEmailSolicitacao() && handleEmail}
//                 onWhatsApp={handleShared}
//               />

//               <Footer.Actions>
//                 <Footer.Count>
//                   {itensCarrinho.itens.length}{' '}
//                   {itensCarrinho.itens.length === 1
//                     ? ITEM[idioma]
//                     : ITEMS[idioma]}
//                 </Footer.Count>

//                 {utilizaSolicitarPecas() &&
//                   (!app ||
//                     action === opTipoAcao.INTEGRACAO_CATALOGO ||
//                     action === opTipoAcao.INTEGRACAO_TOKEN) && (
//                     <Footer.Submit type="submit">
//                       {action === opTipoAcao.INTEGRACAO_TOKEN
//                         ? REQUEST_QUOTE[idioma]
//                         : REQUEST_PARTS[idioma]}
//                     </Footer.Submit>
//                   )}
//               </Footer.Actions>

//               {/* {(!app || action === opTipoAcao.INTEGRACAO_CATALOGO) && (
//                 <Footer.Submit type="submit">
//                   {action === opTipoAcao.INTEGRACAO_TOKEN
//                     ? 'Solicitar Orçamento'
//                     : 'Solicitar Peças'}
//                 </Footer.Submit>
//               )} */}
//             </Footer>
//           </Form>
//         ) : (
//           <Wrapper.NotFound>
//             <MdShoppingCart size={46} />
//             <strong>{NO_ITEM_ADDED_TO_CART[idioma]}</strong>
//             <span>{BROWSE_CATALOG_AND_ADD_PARTS[idioma]}</span>
//             <Wrapper.BackButton type="button" onClick={() => history.push('/')}>
//               <MdArrowBack size={18} />
//               {BACK_TO_CATALOG[idioma]}
//             </Wrapper.BackButton>
//           </Wrapper.NotFound>
//         )}
//       </Wrapper>
//     </Container>
//   );
// }

// export default Carrinho;

// import React, { useCallback, useMemo } from 'react';
// import { useLocation } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';
// import { Scope } from '@unform/core';
// import {
//   MdDelete,
//   MdChevronLeft,
//   MdChevronRight,
//   MdShoppingCart,
//   MdArrowBack,
// } from 'react-icons/md';

// import { AppError } from '../../../errors/AppError';

// import {
//   atualizaQuantidadeRequest,
//   atualizaItemOSRequest,
//   removeCarrinho,
//   limpaCarrinho,
// } from '../../../store/modules/cart/actions';

// import history from '../../../services/history';
// import api from '../../../services/api';

// import { opTipoAcao } from '../../../lib/const';
// import {
//   sendServerEmail,
//   // sendServerWhatsApp,
//   labelExtExtra01,
//   labelExtExtra02,
//   labelExtExtra03,
//   labelExtExtra04,
//   criaItemOSSisma,
//   enviaEmailSolicitacao,
//   usaMotivoFalha,
//   usaAgenteCausa,
//   usaSecaoTrab,
//   utilizaSolicitarPecas,
// } from '../../../lib/paramUtils';
// import { toCSV } from '../../../lib/csv-core';

// import ActionMenu from '../../../components/ActionMenu';

// import TitleBar from '../../../components/TitleBar';

// import { Form } from '../../../components/Form';
// import InputViewer from '../../../components/Form/Input/Viewer';
// import Select from '../../../components/Form/Input/Select';

// import { RowMaster } from '../../../components/Table';

// import { emailTipo } from '../../Usuario/_usuario-email';

// import {
//   Container,
//   Cart,
//   Wrapper,
//   Section,
//   Table,
//   Footer,
//   WrapperItemOS,
//   ItemOSTitle,
//   ItemOSLabel,
//   ItemOSTableLabel,
//   ItemOSTableContent,
//   WrapperTableItemOS,
// } from './styles';
// import {
//   BACK_TO_CATALOG,
//   BROWSE_CATALOG_AND_ADD_PARTS,
//   EXPORT_SHOPPING_LIST,
//   ITEM,
//   ITEMS,
//   MANUFACTURER,
//   MODEL,
//   NO_ERP_CODE_RELATED_TO_MATERIAL,
//   NO_ITEM_ADDED_TO_CART,
//   opIdiomaCatalogo,
//   OTHER_INFORMATION,
//   REQUEST_PARTS,
//   REQUEST_QUOTE,
//   REQUESTER,
//   REVIEW_ITEMS_BEFORE_SUBMITTING,
//   SELECTED_MATERIALS,
//   YOUR_REQUEST,
// } from '../../../lib/idiomaAppOptions';
// // import { whatsAppTipo } from '../../WhatsApp';

// function Carrinho() {
//   const location = useLocation();
//   const dispatch = useDispatch();

//   const selectUser = useSelector((state) => state.user);

//   /** idioma do catálogo escolhido pelo usuário (null = padrão) */
//   const idiomaCatalogo = useSelector(
//     (state) => state.param.idiomaCatalogo || null
//   );

//   const idioma = idiomaCatalogo || opIdiomaCatalogo.BR;

//   const itensCarrinho = useSelector((state) => {
//     const { cart, user } = state;

//     /** dados do carrinho */
//     const {
//       items,
//       order: {
//         extCodiDiv2,
//         extNumeOS,
//         extItemOS,
//         extObservacao,
//         extUsuario,
//         extExtra01,
//         extExtra02,
//         extExtra03,
//         extExtra04,
//       },
//     } = cart;

//     /** dados do usuário */
//     const { profile } = user || {};
//     const { name = '' } = profile || {};

//     /** percorre todos os itens do carrinho */
//     const itens = items.map((item) => {
//       const {
//         materialFabricante,
//         paginaCatalogo,
//         itemOS,
//         partnumber,
//         ...itemRestante
//       } = item;

//       const {
//         catalogo: { modelo },
//       } = paginaCatalogo;

//       // extItemOS.push('0 - Inserir Item Novo na OS');

//       return {
//         ...itemRestante,
//         ...materialFabricante,
//         itemOS,
//         itemOSFormatado: extItemOS.map((sequencia) => ({
//           value: sequencia.value,
//           label: sequencia.label,
//         })),
//         paginaCatalogo,
//         modelo: modelo.map((m) => m.descricao).join(', '),
//         partnumber,
//       };
//     });

//     const extObservacaoFormatada = extObservacao || '';

//     return {
//       extCodiDiv2,
//       extNumeOS,
//       extObservacao: extObservacaoFormatada.split('$n').join('\r\n'),
//       extUsuario,
//       extExtra01,
//       extExtra02,
//       extExtra03,
//       extExtra04,
//       nome: name,
//       itens,
//     };
//   });

//   const { app, action } = useSelector((state) => state.auth || {});

//   const handleExcluir = useCallback(
//     (idCatalogo, idPagina, idItem, idMaterial, materialEmpresa) => {
//       const codimate = materialEmpresa ? materialEmpresa.codimate : null;

//       dispatch(
//         removeCarrinho(idCatalogo, idPagina, idItem, idMaterial, codimate)
//       );
//     },
//     [dispatch]
//   );

//   const handleAdicionar = useCallback(
//     (
//       idCatalogo,
//       idPagina,
//       idItem,
//       idMaterial,
//       materialEmpresa,
//       quantidade = 1
//     ) => {
//       const codimate = materialEmpresa ? materialEmpresa.codimate : null;

//       const itemIndex = codimate
//         ? itensCarrinho.itens.findIndex(
//             (item) =>
//               item.idCatalogo === idCatalogo &&
//               item.idPagina === idPagina &&
//               item.idItem === idItem &&
//               item.idMaterial === idMaterial &&
//               item.materialEmpresa.codimate === codimate
//           )
//         : itensCarrinho.itens.findIndex(
//             (item) =>
//               item.idCatalogo === idCatalogo &&
//               item.idPagina === idPagina &&
//               item.idItem === idItem &&
//               item.idMaterial === idMaterial
//           );

//       if (itemIndex >= 0) {
//         const quantidadeTotal =
//           itensCarrinho.itens[itemIndex].quantidadeTotal + quantidade;

//         dispatch(
//           atualizaQuantidadeRequest(
//             idCatalogo,
//             idPagina,
//             idItem,
//             idMaterial,
//             quantidadeTotal,
//             codimate
//           )
//         );
//       }
//     },
//     [itensCarrinho, dispatch]
//   );

//   const handleRemover = useCallback(
//     (
//       idCatalogo,
//       idPagina,
//       idItem,
//       idMaterial,
//       materialEmpresa,
//       quantidade = 1
//     ) => {
//       const codimate = materialEmpresa ? materialEmpresa.codimate : null;

//       const itemIndex = codimate
//         ? itensCarrinho.itens.findIndex(
//             (item) =>
//               item.idCatalogo === idCatalogo &&
//               item.idPagina === idPagina &&
//               item.idItem === idItem &&
//               item.idMaterial === idMaterial &&
//               item.materialEmpresa.codimate === codimate
//           )
//         : itensCarrinho.itens.findIndex(
//             (item) =>
//               item.idCatalogo === idCatalogo &&
//               item.idPagina === idPagina &&
//               item.idItem === idItem &&
//               item.idMaterial === idMaterial
//           );

//       if (itemIndex >= 0) {
//         const quantidadeTotal =
//           itensCarrinho.itens[itemIndex].quantidadeTotal - quantidade;

//         dispatch(
//           atualizaQuantidadeRequest(
//             idCatalogo,
//             idPagina,
//             idItem,
//             idMaterial,
//             quantidadeTotal,
//             codimate
//           )
//         );
//       }
//     },
//     [itensCarrinho, dispatch]
//   );

//   const handleSelecionado = useCallback(
//     ({ value }, idCatalogo, idPagina, idItem, idMaterial, materialEmpresa) => {
//       const codimate = materialEmpresa ? materialEmpresa.codimate : null;

//       dispatch(
//         atualizaItemOSRequest(
//           idCatalogo,
//           idPagina,
//           idItem,
//           idMaterial,
//           value,
//           codimate
//         )
//       );
//     },
//     [dispatch]
//   );

//   const handleExportar = useCallback(() => {
//     const data = itensCarrinho.itens.map((item) => {
//       const {
//         materialEmpresa,
//         partnumber,
//         descricao,
//         especTecnica,
//         modelo,
//         fabricante: { descricao: fabricante },
//         quantidade,
//         quantidadeTotal,
//         paginaCatalogo: {
//           descricao: pagina,
//           catalogo: { nome: catalogo, versao },
//         },
//       } = item;

//       const {
//         codimate: codimateERP = null,
//         descricao: descricaoERP = null,
//         unidade: unidadeERP = null,
//       } = materialEmpresa || {};

//       return [
//         codimateERP,
//         descricaoERP,
//         unidadeERP,
//         partnumber,
//         descricao,
//         especTecnica,
//         modelo,
//         fabricante,
//         quantidade,
//         quantidadeTotal,
//         pagina,
//         catalogo,
//         versao,
//       ];
//     });

//     const fields = [
//       'Código Material (ERP)',
//       'Descrição (ERP)',
//       'Unidade (ERP)',
//       'Partnumber',
//       'Descrição',
//       'Espec. Técnica',
//       'Modelo',
//       'Fabricante',
//       'Quantidade Catálogo',
//       'Quantidade Solicitada',
//       'Página',
//       'Catálogo',
//       'Versão',
//     ];

//     const csv = toCSV(fields, data);

//     try {
//       /** cria um link para o processo de download */
//       const link = document.createElement('a');
//       const file = `data:text/csv;charset=utf-8,%EF%BB%BF${encodeURI(csv)}`;

//       link.href = file;
//       link.download = `catalogo-eletronico-carrinho.csv`;

//       document.body.appendChild(link);
//       link.click();

//       document.body.removeChild(link);
//     } catch (err) {
//       AppError(err);
//     }
//   }, [itensCarrinho]);

//   const handleEmail = useCallback(
//     async (paraEmpresa = false, emailData = null) => {
//       const data = itensCarrinho.itens.map((item) => {
//         const {
//           materialEmpresa,
//           partnumber,
//           descricao,
//           especTecnica,
//           modelo,
//           fabricante: { descricao: fabricante },
//           quantidade,
//           quantidadeTotal,
//           paginaCatalogo: {
//             descricao: pagina,
//             catalogo: { nome: catalogo, versao },
//           },
//         } = item;

//         const {
//           codimate: codimateERP = null,
//           descricao: descricaoERP = null,
//           unidade: unidadeERP = null,
//         } = materialEmpresa || {};

//         return [
//           codimateERP,
//           descricaoERP,
//           unidadeERP,
//           partnumber,
//           descricao,
//           especTecnica,
//           modelo,
//           fabricante,
//           quantidade,
//           quantidadeTotal,
//           pagina,
//           catalogo,
//           versao,
//         ];
//       });

//       const fields = [
//         'Código Material (ERP)',
//         'Descrição (ERP)',
//         'Unidade (ERP)',
//         'Partnumber',
//         'Descrição',
//         'Espec. Técnica',
//         'Modelo',
//         'Fabricante',
//         'Quantidade Catálogo',
//         'Quantidade Solicitada',
//         'Página',
//         'Catálogo',
//         'Versão',
//       ];

//       try {
//         const csv = toCSV(fields, data);
//         const blobFile = new Blob([`\uFEFF${csv}`], {
//           type: 'text/csv;charset=utf-8;',
//         });

//         /** verifica parâmetro para envio de e-mail pelo servidor ou serviço próprio */
//         if (sendServerEmail()) {
//           history.push('/enviar-email', {
//             background: location,
//             tipo: emailTipo.EMAIL_CARRINHO,
//             paraEmpresa,
//             data: { attachment: blobFile, emailData },
//           });
//         } else {
//           const formData = new FormData();
//           formData.append('file', blobFile);

//           const response = await api.post('email', formData);
//           const { path } = response.data;

//           const subject = encodeURIComponent(
//             `Catálogo Eletrônico - Lista de Compras`
//           );
//           const body = encodeURIComponent(
//             `Olá,\n\nSegue link para download da lista de compras:\n${path}\n\nAssiste - Catálogo Eletrônico`
//           );

//           /** cria um link para o processo de download */
//           const link = document.createElement('a');
//           link.href = `mailto:nome@endereco.com?subject=${subject}&body=${body}`;

//           document.body.appendChild(link);
//           link.click();

//           document.body.removeChild(link);
//         }
//       } catch (err) {
//         AppError(err);
//       }
//     },
//     [location, itensCarrinho]
//   );

//   // const handleWhatsApp = useCallback(
//   //   () => async (paraEmpresa = false) => {
//   //     const data = itensCarrinho.itens.map((item) => {
//   //       const {
//   //         materialEmpresa,
//   //         partnumber,
//   //         descricao,
//   //         especTecnica,
//   //         modelo,
//   //         fabricante: { descricao: fabricante },
//   //         quantidade,
//   //         quantidadeTotal,
//   //         paginaCatalogo: {
//   //           descricao: pagina,
//   //           catalogo: { nome: catalogo, versao },
//   //         },
//   //       } = item;

//   //       const {
//   //         codimate: codimateERP = null,
//   //         descricao: descricaoERP = null,
//   //         unidade: unidadeERP = null,
//   //       } = materialEmpresa || {};

//   //       return [
//   //         codimateERP,
//   //         descricaoERP,
//   //         unidadeERP,
//   //         partnumber,
//   //         descricao,
//   //         especTecnica,
//   //         modelo,
//   //         fabricante,
//   //         quantidade,
//   //         quantidadeTotal,
//   //         pagina,
//   //         catalogo,
//   //         versao,
//   //       ];
//   //     });

//   //     const fields = [
//   //       'Código Material (ERP)',
//   //       'Descrição (ERP)',
//   //       'Unidade (ERP)',
//   //       'Partnumber',
//   //       'Descrição',
//   //       'Espec. Técnica',
//   //       'Modelo',
//   //       'Fabricante',
//   //       'Quantidade Catálogo',
//   //       'Quantidade Solicitada',
//   //       'Página',
//   //       'Catálogo',
//   //       'Versão',
//   //     ];

//   //     try {
//   //       const csv = toCSV(fields, data);
//   //       const blobFile = new Blob([`\uFEFF${csv}`], {
//   //         type: 'text/csv;charset=utf-8;',
//   //       });

//   //       /** verifica parâmetro para envio de e-mail pelo servidor ou serviço próprio */
//   //       if (sendServerWhatsApp()) {
//   //         history.push('/whatsapp', {
//   //           background: location,
//   //           tipo: whatsAppTipo.WHATSAPP_CARRINHO,
//   //           paraEmpresa,
//   //           data: { attachment: blobFile },
//   //         });
//   //       } else {
//   //         const formData = new FormData();
//   //         formData.append('file', blobFile);

//   //         const response = await api.post('email', formData);
//   //         const { path } = response.data;

//   //         const subject = encodeURIComponent(
//   //           `Catálogo Eletrônico - Lista de Compras`
//   //         );
//   //         const body = encodeURIComponent(
//   //           `Olá,\n\nSegue link para download da lista de compras:\n${path}\n\nAssiste - Catálogo Eletrônico`
//   //         );

//   //         /** cria um link para o processo de download */
//   //         const link = document.createElement('a');
//   //         link.href = `mailto:nome@endereco.com?subject=${subject}&body=${body}`;

//   //         document.body.appendChild(link);
//   //         link.click();

//   //         document.body.removeChild(link);
//   //       }
//   //     } catch (err) {
//   //       AppError(err);
//   //     }
//   //   },
//   //   [location, itensCarrinho]
//   // );

//   const handleConfirmar = useCallback(async () => {
//     /** solicitação por token */
//     if (action === opTipoAcao.INTEGRACAO_TOKEN) {
//       handleEmail(true);
//       return;
//     }

//     if (enviaEmailSolicitacao()) {
//       const { adm, email, empresa, login, name, userId } = selectUser.profile;
//       const { descricao, email: emailEmpresa, idEmpresa, url } = empresa;

//       const emailData = {
//         adm,
//         email,
//         empresa,
//         login,
//         name,
//         userId,
//         descricao,
//         emailEmpresa,
//         idEmpresa,
//         url,
//       };

//       /**
//        * CHAMAR A TELA DE ENVIO DE E-MAIL IGUAL ESTA EM
//        * EXPORTAR LISTA DE COMPRAS > ENVIAR E
//        */

//       handleEmail({ paraEmpresa: false, emailData });
//       return;
//     }

//     try {
//       const {
//         extCodiDiv2,
//         extNumeOS,
//         extObservacao,
//         extUsuario,
//         extExtra01,
//         extExtra02,
//         extExtra03,
//         extExtra04,
//       } = itensCarrinho;

//       const response = await api.post('/solicitacao', {
//         extCodiDiv2,
//         extNumeOS,
//         extObservacao,
//         extUsuario,
//         extExtra01,
//         extExtra02,
//         extExtra03,
//         extExtra04,
//         itensCarrinho: itensCarrinho.itens,
//       });

//       const { idSolicitacao } = response.data;

//       /** limpa itens do carrinho */
//       dispatch(limpaCarrinho());

//       /** redireciona para página de solicitação */
//       history.push('/checkout', { id: idSolicitacao });
//     } catch (err) {
//       AppError(err);
//     }
//   }, [dispatch, itensCarrinho, action, handleEmail]);

//   /** sincroniza rótulos */
//   const rotuloExtExtra01 = useMemo(() => labelExtExtra01(), []);
//   const rotuloExtExtra02 = useMemo(() => labelExtExtra02(), []);
//   const rotuloExtExtra03 = useMemo(() => labelExtExtra03(), []);
//   const rotuloExtExtra04 = useMemo(() => labelExtExtra04(), []);

//   const redirectToPage = useCallback((idCatalogo, idPagina) => {
//     api
//       .get(`/catalogo/${idCatalogo}/nivel-classificacao/pagina/${idPagina}`)
//       .then((response) => {
//         const { data } = response;

//         const {
//           idNivel,
//           relacNivel: { nivel },
//         } = data;

//         history.push(
//           `/catalogo.partes/${idCatalogo}?IDN_${nivel}=${idNivel}&IDP=${idPagina}`
//         );
//       })
//       .catch((erro) => {
//         console.error(erro);
//       });
//   }, []);

//   return (
//     <Container>
//       <TitleBar back title={SELECTED_MATERIALS[idioma]} width={950} />
//       <Wrapper>
//         {itensCarrinho.itens.length > 0 ? (
//           <Form initialData={itensCarrinho} onSubmit={handleConfirmar}>
//             <Cart.Header>
//               <Cart.HeaderTitle>
//                 <strong>{YOUR_REQUEST[idioma]}</strong>
//                 <span>{REVIEW_ITEMS_BEFORE_SUBMITTING[idioma]}</span>
//               </Cart.HeaderTitle>
//               <Cart.HeaderMeta>
//                 <Cart.Count>
//                   {itensCarrinho.itens.length}{' '}
//                   {itensCarrinho.itens.length === 1
//                     ? ITEM[idioma]
//                     : ITEMS[idioma]}
//                 </Cart.Count>
//                 {/* <Cart.Tag>Sem valores</Cart.Tag> */}
//               </Cart.HeaderMeta>
//             </Cart.Header>

//             <Table>
//               <thead>
//                 <tr>
//                   <th> </th>
//                   <th>Partnumber</th>
//                   <th>Descrição</th>
//                   <th>Quantidade</th>
//                   <th> </th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {itensCarrinho.itens.map((item, index) => (
//                   <RowMaster key={index} noCursoPointer>
//                     <td>
//                       <Wrapper.BtnImg
//                         onClick={() =>
//                           redirectToPage(item.idCatalogo, item.idPagina)
//                         }
//                       >
//                         <Cart.ItemNo>{index + 1}</Cart.ItemNo>
//                         <img src={item.imagemCatalogo} alt="Imagem catálogo" />
//                       </Wrapper.BtnImg>
//                     </td>
//                     <td>
//                       <strong>{item.partnumber}</strong>
//                     </td>
//                     <td>
//                       <Table.Description>
//                         <strong>{item.descricao}</strong>
//                         <span>{`${MODEL[idioma]}: ${item.modelo}`}</span>
//                         <span>{`${MANUFACTURER[idioma]}: ${item.fabricante.descricao}`}</span>
//                         {/* <span>{`Fabricante: ${item.materialFabricante.descricao}`}</span> */}
//                         {/* <span>{`Fabricante: ${item.materialEmpresa}`}</span> */}
//                         {item.materialEmpresa ? (
//                           <>
//                             <span>{`Código ERP: ${item.materialEmpresa.codimate}`}</span>
//                             {item.materialEmpresa.paralelo === '1' && (
//                               <Table.Error>
//                                 Atenção: O material selecionado está cadastrado
//                                 como não original
//                               </Table.Error>
//                             )}
//                           </>
//                         ) : (
//                           <Table.Error>
//                             {NO_ERP_CODE_RELATED_TO_MATERIAL[idioma]}
//                           </Table.Error>
//                         )}

//                         {!criaItemOSSisma() && itensCarrinho.extNumeOS && (
//                           <Scope path={`extItensOS[${index}]`}>
//                             <InputViewer
//                               id="itemKey"
//                               name="itemKey"
//                               defaultValue={index}
//                               isHidden
//                             />
//                             <Table.Combo>
//                               Item O.S.:
//                               <Select
//                                 id="itemValue"
//                                 name="itemValue"
//                                 options={item.itemOSFormatado}
//                                 isSearchable
//                                 defaultValue={
//                                   item.itemOS
//                                     ? item.itemOSFormatado.filter(
//                                         (i) => i.value === item.itemOS
//                                       )
//                                     : item.itemOSFormatado[0]
//                                 }
//                                 width={300}
//                                 onChange={(select) =>
//                                   handleSelecionado(
//                                     select,
//                                     item.idCatalogo,
//                                     item.idPagina,
//                                     item.idItem,
//                                     item.idMaterial,
//                                     item.materialEmpresa
//                                   )
//                                 }
//                               />
//                             </Table.Combo>
//                           </Scope>
//                         )}
//                         {criaItemOSSisma() && (
//                           <>
//                             {(usaMotivoFalha() ||
//                               usaAgenteCausa() ||
//                               usaSecaoTrab()) && (
//                               <WrapperItemOS>
//                                 <ItemOSTitle>Criação Item OS:</ItemOSTitle>
//                                 <WrapperTableItemOS>
//                                   <ItemOSTableLabel>
//                                     {usaMotivoFalha() && (
//                                       <span>Agente Causa: </span>
//                                     )}
//                                     {usaAgenteCausa() && (
//                                       <span>Motivo Falha: </span>
//                                     )}
//                                     {usaSecaoTrab() && (
//                                       <span>Seção Trabalho: </span>
//                                     )}
//                                   </ItemOSTableLabel>
//                                   <ItemOSTableContent>
//                                     {usaMotivoFalha() && (
//                                       <p>
//                                         <span>
//                                           {item.agenteCausa.codiAgente} -{' '}
//                                         </span>
//                                         <span>
//                                           {item.agenteCausa.descricao}
//                                         </span>
//                                       </p>
//                                     )}
//                                     {usaAgenteCausa() && (
//                                       <p>
//                                         <span>
//                                           {item.motivoFalha.codiMofa} -{' '}
//                                         </span>
//                                         <span>
//                                           {item.motivoFalha.descricao}
//                                         </span>
//                                       </p>
//                                     )}
//                                     {usaSecaoTrab() && (
//                                       <p>
//                                         <span>
//                                           {item.secaoTrab.codiSetr} -{' '}
//                                         </span>
//                                         <span>{item.secaoTrab.descrResum}</span>
//                                       </p>
//                                     )}
//                                   </ItemOSTableContent>
//                                 </WrapperTableItemOS>
//                               </WrapperItemOS>
//                             )}
//                             <WrapperItemOS>
//                               <ItemOSTitle>Composição:</ItemOSTitle>
//                               <WrapperTableItemOS>
//                                 <ItemOSTableLabel>
//                                   <span>Sistema: </span>
//                                   <span>Local: </span>
//                                 </ItemOSTableLabel>
//                                 <ItemOSTableContent>
//                                   <p>
//                                     <span>{item.sistema.codiSist} - </span>
//                                     <span>{item.sistema.descricao}</span>
//                                   </p>
//                                   <p>
//                                     <span>{item.local.codiLoca} - </span>
//                                     <span>{item.local.descricao}</span>
//                                   </p>
//                                 </ItemOSTableContent>
//                               </WrapperTableItemOS>
//                             </WrapperItemOS>
//                           </>
//                         )}
//                       </Table.Description>
//                     </td>
//                     <td>
//                       <strong>
//                         <Table.Quantity>
//                           <button
//                             type="button"
//                             onClick={() =>
//                               handleRemover(
//                                 item.idCatalogo,
//                                 item.idPagina,
//                                 item.idItem,
//                                 item.idMaterial,
//                                 item.materialEmpresa
//                               )
//                             }
//                           >
//                             <MdChevronLeft size={25} />
//                           </button>
//                           <span>{item.quantidadeTotal}</span>
//                           <button
//                             type="button"
//                             onClick={() =>
//                               handleAdicionar(
//                                 item.idCatalogo,
//                                 item.idPagina,
//                                 item.idItem,
//                                 item.idMaterial,
//                                 item.materialEmpresa
//                               )
//                             }
//                           >
//                             <MdChevronRight size={25} />
//                           </button>
//                         </Table.Quantity>
//                       </strong>
//                     </td>
//                     <td>
//                       <Table.Action>
//                         <Table.BtnRemove
//                           type="button"
//                           onClick={() =>
//                             handleExcluir(
//                               item.idCatalogo,
//                               item.idPagina,
//                               item.idItem,
//                               item.idMaterial,
//                               item.materialEmpresa
//                             )
//                           }
//                         >
//                           <MdDelete size={25} />
//                         </Table.BtnRemove>
//                       </Table.Action>
//                     </td>
//                   </RowMaster>
//                 ))}
//               </tbody>
//             </Table>

//             <Section>
//               <Form.Title>{OTHER_INFORMATION[idioma]}</Form.Title>
//               <Form.Column>
//                 <Form.Row>
//                   <InputViewer
//                     id="nome"
//                     name="nome"
//                     label={`${REQUESTER[idioma]}:`}
//                     asRow
//                   />
//                 </Form.Row>
//                 {itensCarrinho.extNumeOS && (
//                   <>
//                     <InputViewer id="extCodiDiv2" name="extCodiDiv2" isHidden />
//                     <Form.Row>
//                       <InputViewer
//                         id="extNumeOS"
//                         name="extNumeOS"
//                         label="Nº OS:"
//                         asRow
//                       />
//                     </Form.Row>
//                   </>
//                 )}
//                 {itensCarrinho.extUsuario && (
//                   <Form.Row>
//                     <InputViewer
//                       id="extUsuario"
//                       name="extUsuario"
//                       label="Usuário:"
//                       asRow
//                     />
//                   </Form.Row>
//                 )}
//                 {itensCarrinho.extExtra01 && (
//                   <Form.Row>
//                     <InputViewer
//                       id="extExtra01"
//                       name="extExtra01"
//                       label={rotuloExtExtra01}
//                       asRow
//                     />
//                   </Form.Row>
//                 )}
//                 {itensCarrinho.extExtra02 && (
//                   <Form.Row>
//                     <InputViewer
//                       id="extExtra02"
//                       name="extExtra02"
//                       label={rotuloExtExtra02}
//                       asRow
//                     />
//                   </Form.Row>
//                 )}
//                 {itensCarrinho.extExtra03 && (
//                   <Form.Row>
//                     <InputViewer
//                       id="extExtra03"
//                       name="extExtra03"
//                       label={rotuloExtExtra03}
//                       asRow
//                     />
//                   </Form.Row>
//                 )}
//                 {itensCarrinho.extExtra04 && (
//                   <Form.Row>
//                     <InputViewer
//                       id="extExtra04"
//                       name="extExtra04"
//                       label={rotuloExtExtra04}
//                       asRow
//                     />
//                   </Form.Row>
//                 )}
//                 {itensCarrinho.extObservacao && (
//                   <Form.Row>
//                     <InputViewer
//                       id="extObservacao"
//                       name="extObservacao"
//                       type="textarea"
//                     />
//                   </Form.Row>
//                 )}
//               </Form.Column>
//             </Section>

//             <Footer>
//               <ActionMenu
//                 Icon={EXPORT_SHOPPING_LIST[idioma]}
//                 onExportCSV={handleExportar}
//                 onMail={!enviaEmailSolicitacao() && handleEmail}
//                 // onWhatsApp={handleWhatsApp}
//               />

//               <Footer.Actions>
//                 <Footer.Count>
//                   {itensCarrinho.itens.length}{' '}
//                   {itensCarrinho.itens.length === 1
//                     ? ITEM[idioma]
//                     : ITEMS[idioma]}
//                 </Footer.Count>

//                 {utilizaSolicitarPecas() &&
//                   (!app || action === opTipoAcao.INTEGRACAO_CATALOGO) && (
//                     <Footer.Submit type="submit">
//                       {action === opTipoAcao.INTEGRACAO_TOKEN
//                         ? REQUEST_QUOTE[idioma]
//                         : REQUEST_PARTS[idioma]}
//                     </Footer.Submit>
//                   )}
//               </Footer.Actions>

//               {/* {(!app || action === opTipoAcao.INTEGRACAO_CATALOGO) && (
//                 <Footer.Submit type="submit">
//                   {action === opTipoAcao.INTEGRACAO_TOKEN
//                     ? 'Solicitar Orçamento'
//                     : 'Solicitar Peças'}
//                 </Footer.Submit>
//               )} */}
//             </Footer>
//           </Form>
//         ) : (
//           <Wrapper.NotFound>
//             <MdShoppingCart size={46} />
//             <strong>{NO_ITEM_ADDED_TO_CART[idioma]}</strong>
//             <span>{BROWSE_CATALOG_AND_ADD_PARTS[idioma]}</span>
//             <Wrapper.BackButton type="button" onClick={() => history.push('/')}>
//               <MdArrowBack size={18} />
//               {BACK_TO_CATALOG[idioma]}
//             </Wrapper.BackButton>
//           </Wrapper.NotFound>
//         )}
//       </Wrapper>
//     </Container>
//   );
// }

// export default Carrinho;

import React, { useCallback, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Scope } from '@unform/core';
import {
  MdDelete,
  MdChevronLeft,
  MdChevronRight,
  MdShoppingCart,
  MdArrowBack,
} from 'react-icons/md';

import { toast } from 'react-toastify';
import { AppError } from '../../../errors/AppError';

import {
  atualizaQuantidadeRequest,
  atualizaItemOSRequest,
  removeCarrinho,
  limpaCarrinho,
} from '../../../store/modules/cart/actions';

import history from '../../../services/history';
import api from '../../../services/api';

import { opTipoAcao } from '../../../lib/const';
import {
  sendServerEmail,
  // sendServerWhatsApp,
  labelExtExtra01,
  labelExtExtra02,
  labelExtExtra03,
  labelExtExtra04,
  criaItemOSSisma,
  enviaEmailSolicitacao,
  usaMotivoFalha,
  usaAgenteCausa,
  usaSecaoTrab,
  utilizaSolicitarPecas,
  removeERPHome,
} from '../../../lib/paramUtils';
import { toCSV } from '../../../lib/csv-core';

import ActionMenu from '../../../components/ActionMenu';

import TitleBar from '../../../components/TitleBar';

import { Form } from '../../../components/Form';
import InputViewer from '../../../components/Form/Input/Viewer';
import Select from '../../../components/Form/Input/Select';

import { RowMaster } from '../../../components/Table';

import { emailTipo } from '../../Usuario/_usuario-email';

import {
  Container,
  Cart,
  Wrapper,
  Section,
  Table,
  Footer,
  WrapperItemOS,
  ItemOSTitle,
  ItemOSLabel,
  ItemOSTableLabel,
  ItemOSTableContent,
  WrapperTableItemOS,
} from './styles';
import {
  BACK_TO_CATALOG,
  BROWSE_CATALOG_AND_ADD_PARTS,
  EXPORT_SHOPPING_LIST,
  ITEM,
  ITEMS,
  MANUFACTURER,
  MODEL,
  NO_ERP_CODE_RELATED_TO_MATERIAL,
  NO_ITEM_ADDED_TO_CART,
  opIdiomaCatalogo,
  OTHER_INFORMATION,
  REQUEST_PARTS,
  REQUEST_QUOTE,
  REQUESTER,
  REVIEW_ITEMS_BEFORE_SUBMITTING,
  SELECTED_MATERIALS,
  YOUR_REQUEST,
} from '../../../lib/idiomaAppOptions';
// import { whatsAppTipo } from '../../WhatsApp';

function Carrinho() {
  const location = useLocation();
  const dispatch = useDispatch();

  const selectUser = useSelector((state) => state.user);

  const profile = useSelector((state) => {
    const { userId, name = '', adm, empresa } = state.user.profile || {};
    const { idEmpresa, url: logotipo } = empresa || {};

    return { userId, name, adm, idEmpresa, url: logotipo };
  });

  const carrinho = useSelector((state) =>
    state.cart.items.map((item) => ({
      ...item,
      ...item.materialFabricante,
    }))
  );

  /** idioma do catálogo escolhido pelo usuário (null = padrão) */
  const idiomaCatalogo = useSelector(
    (state) => state.param.idiomaCatalogo || null
  );

  /** e-mail do deep-link SSO (destinatário do orçamento/solicitação) */
  const ssoQuoteEmail = useSelector(
    (state) => (state.param.sso && state.param.sso.quoteEmail) || null
  );

  const idioma = idiomaCatalogo || opIdiomaCatalogo.BR;

  /**
   * Parâmetro global 35 (REMOVE_ERP_HOME): oculta o Código ERP do material na
   * Home. Aqui suprime o aviso de material sem Código ERP relacionado nos
   * itens do carrinho.
   */
  const ocultaERPHome = removeERPHome();

  const itensCarrinho = useSelector((state) => {
    const { cart, user } = state;

    /** dados do carrinho */
    const {
      items,
      order: {
        extCodiDiv2,
        extNumeOS,
        extItemOS,
        extObservacao,
        extUsuario,
        extExtra01,
        extExtra02,
        extExtra03,
        extExtra04,
      },
    } = cart;

    /** dados do usuário */
    const { profile } = user || {};
    const { name = '' } = profile || {};

    /** percorre todos os itens do carrinho */
    const itens = items.map((item) => {
      const {
        materialFabricante,
        paginaCatalogo,
        itemOS,
        partnumber,
        ...itemRestante
      } = item;

      const {
        catalogo: { modelo },
      } = paginaCatalogo;

      // extItemOS.push('0 - Inserir Item Novo na OS');

      return {
        ...itemRestante,
        ...materialFabricante,
        itemOS,
        itemOSFormatado: extItemOS.map((sequencia) => ({
          value: sequencia.value,
          label: sequencia.label,
        })),
        paginaCatalogo,
        modelo: modelo.map((m) => m.descricao).join(', '),
        partnumber,
      };
    });

    const extObservacaoFormatada = extObservacao || '';

    return {
      extCodiDiv2,
      extNumeOS,
      extObservacao: extObservacaoFormatada.split('$n').join('\r\n'),
      extUsuario,
      extExtra01,
      extExtra02,
      extExtra03,
      extExtra04,
      nome: name,
      itens,
    };
  });

  const { app, action } = useSelector((state) => state.auth || {});

  const handleExcluir = useCallback(
    (idCatalogo, idPagina, idItem, idMaterial, materialEmpresa) => {
      const codimate = materialEmpresa ? materialEmpresa.codimate : null;

      dispatch(
        removeCarrinho(idCatalogo, idPagina, idItem, idMaterial, codimate)
      );
    },
    [dispatch]
  );

  const handleAdicionar = useCallback(
    (
      idCatalogo,
      idPagina,
      idItem,
      idMaterial,
      materialEmpresa,
      quantidade = 1
    ) => {
      const codimate = materialEmpresa ? materialEmpresa.codimate : null;

      const itemIndex = codimate
        ? itensCarrinho.itens.findIndex(
            (item) =>
              item.idCatalogo === idCatalogo &&
              item.idPagina === idPagina &&
              item.idItem === idItem &&
              item.idMaterial === idMaterial &&
              item.materialEmpresa.codimate === codimate
          )
        : itensCarrinho.itens.findIndex(
            (item) =>
              item.idCatalogo === idCatalogo &&
              item.idPagina === idPagina &&
              item.idItem === idItem &&
              item.idMaterial === idMaterial
          );

      if (itemIndex >= 0) {
        const quantidadeTotal =
          itensCarrinho.itens[itemIndex].quantidadeTotal + quantidade;

        dispatch(
          atualizaQuantidadeRequest(
            idCatalogo,
            idPagina,
            idItem,
            idMaterial,
            quantidadeTotal,
            codimate
          )
        );
      }
    },
    [itensCarrinho, dispatch]
  );

  const handleRemover = useCallback(
    (
      idCatalogo,
      idPagina,
      idItem,
      idMaterial,
      materialEmpresa,
      quantidade = 1
    ) => {
      const codimate = materialEmpresa ? materialEmpresa.codimate : null;

      const itemIndex = codimate
        ? itensCarrinho.itens.findIndex(
            (item) =>
              item.idCatalogo === idCatalogo &&
              item.idPagina === idPagina &&
              item.idItem === idItem &&
              item.idMaterial === idMaterial &&
              item.materialEmpresa.codimate === codimate
          )
        : itensCarrinho.itens.findIndex(
            (item) =>
              item.idCatalogo === idCatalogo &&
              item.idPagina === idPagina &&
              item.idItem === idItem &&
              item.idMaterial === idMaterial
          );

      if (itemIndex >= 0) {
        const quantidadeTotal =
          itensCarrinho.itens[itemIndex].quantidadeTotal - quantidade;

        dispatch(
          atualizaQuantidadeRequest(
            idCatalogo,
            idPagina,
            idItem,
            idMaterial,
            quantidadeTotal,
            codimate
          )
        );
      }
    },
    [itensCarrinho, dispatch]
  );

  const handleSelecionado = useCallback(
    ({ value }, idCatalogo, idPagina, idItem, idMaterial, materialEmpresa) => {
      const codimate = materialEmpresa ? materialEmpresa.codimate : null;

      dispatch(
        atualizaItemOSRequest(
          idCatalogo,
          idPagina,
          idItem,
          idMaterial,
          value,
          codimate
        )
      );
    },
    [dispatch]
  );

  const handleExportar = useCallback(() => {
    const data = itensCarrinho.itens.map((item) => {
      const {
        materialEmpresa,
        partnumber,
        descricao,
        especTecnica,
        modelo,
        fabricante: { descricao: fabricante },
        quantidade,
        quantidadeTotal,
        paginaCatalogo: {
          descricao: pagina,
          catalogo: { nome: catalogo, versao },
        },
      } = item;

      const {
        codimate: codimateERP = null,
        descricao: descricaoERP = null,
        unidade: unidadeERP = null,
      } = materialEmpresa || {};

      return [
        codimateERP,
        descricaoERP,
        unidadeERP,
        partnumber,
        descricao,
        especTecnica,
        modelo,
        fabricante,
        quantidade,
        quantidadeTotal,
        pagina,
        catalogo,
        versao,
      ];
    });

    const fields = [
      'Código Material (ERP)',
      'Descrição (ERP)',
      'Unidade (ERP)',
      'Partnumber',
      'Descrição',
      'Espec. Técnica',
      'Modelo',
      'Fabricante',
      'Quantidade Catálogo',
      'Quantidade Solicitada',
      'Página',
      'Catálogo',
      'Versão',
    ];

    const csv = toCSV(fields, data);

    try {
      /** cria um link para o processo de download */
      const link = document.createElement('a');
      const file = `data:text/csv;charset=utf-8,%EF%BB%BF${encodeURI(csv)}`;

      link.href = file;
      link.download = `catalogo-eletronico-carrinho.csv`;

      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
    } catch (err) {
      AppError(err);
    }
  }, [itensCarrinho]);

  const handleEmail = useCallback(
    async (paraEmpresa = false, emailData = null) => {
      const data = itensCarrinho.itens.map((item) => {
        const {
          materialEmpresa,
          partnumber,
          descricao,
          especTecnica,
          modelo,
          fabricante: { descricao: fabricante },
          quantidade,
          quantidadeTotal,
          paginaCatalogo: {
            descricao: pagina,
            catalogo: { nome: catalogo, versao },
          },
        } = item;

        const {
          codimate: codimateERP = null,
          descricao: descricaoERP = null,
          unidade: unidadeERP = null,
        } = materialEmpresa || {};

        return [
          codimateERP,
          descricaoERP,
          unidadeERP,
          partnumber,
          descricao,
          especTecnica,
          modelo,
          fabricante,
          quantidade,
          quantidadeTotal,
          pagina,
          catalogo,
          versao,
        ];
      });

      const fields = [
        'Código Material (ERP)',
        'Descrição (ERP)',
        'Unidade (ERP)',
        'Partnumber',
        'Descrição',
        'Espec. Técnica',
        'Modelo',
        'Fabricante',
        'Quantidade Catálogo',
        'Quantidade Solicitada',
        'Página',
        'Catálogo',
        'Versão',
      ];

      try {
        const csv = toCSV(fields, data);
        const blobFile = new Blob([`\uFEFF${csv}`], {
          type: 'text/csv;charset=utf-8;',
        });

        /** verifica parâmetro para envio de e-mail pelo servidor ou serviço próprio */
        if (sendServerEmail()) {
          history.push('/enviar-email', {
            background: location,
            tipo: emailTipo.EMAIL_CARRINHO,
            paraEmpresa,
            data: { attachment: blobFile, emailData },
          });
        } else {
          const formData = new FormData();
          formData.append('file', blobFile);

          const response = await api.post('email', formData);
          const { path } = response.data;

          const subject = encodeURIComponent(
            `Catálogo Eletrônico - Lista de Compras`
          );
          const body = encodeURIComponent(
            `Olá,\n\nSegue link para download da lista de compras:\n${path}\n\nAssiste - Catálogo Eletrônico`
          );

          /** cria um link para o processo de download */
          const link = document.createElement('a');
          link.href = `mailto:${
            ssoQuoteEmail || 'nome@endereco.com'
          }?subject=${subject}&body=${body}`;

          document.body.appendChild(link);
          link.click();

          document.body.removeChild(link);
        }
      } catch (err) {
        AppError(err);
      }
    },
    [location, itensCarrinho, ssoQuoteEmail]
  );

  // const handleWhatsApp = useCallback(
  //   () => async (paraEmpresa = false) => {
  //     const data = itensCarrinho.itens.map((item) => {
  //       const {
  //         materialEmpresa,
  //         partnumber,
  //         descricao,
  //         especTecnica,
  //         modelo,
  //         fabricante: { descricao: fabricante },
  //         quantidade,
  //         quantidadeTotal,
  //         paginaCatalogo: {
  //           descricao: pagina,
  //           catalogo: { nome: catalogo, versao },
  //         },
  //       } = item;

  //       const {
  //         codimate: codimateERP = null,
  //         descricao: descricaoERP = null,
  //         unidade: unidadeERP = null,
  //       } = materialEmpresa || {};

  //       return [
  //         codimateERP,
  //         descricaoERP,
  //         unidadeERP,
  //         partnumber,
  //         descricao,
  //         especTecnica,
  //         modelo,
  //         fabricante,
  //         quantidade,
  //         quantidadeTotal,
  //         pagina,
  //         catalogo,
  //         versao,
  //       ];
  //     });

  //     const fields = [
  //       'Código Material (ERP)',
  //       'Descrição (ERP)',
  //       'Unidade (ERP)',
  //       'Partnumber',
  //       'Descrição',
  //       'Espec. Técnica',
  //       'Modelo',
  //       'Fabricante',
  //       'Quantidade Catálogo',
  //       'Quantidade Solicitada',
  //       'Página',
  //       'Catálogo',
  //       'Versão',
  //     ];

  //     try {
  //       const csv = toCSV(fields, data);
  //       const blobFile = new Blob([`\uFEFF${csv}`], {
  //         type: 'text/csv;charset=utf-8;',
  //       });

  //       /** verifica parâmetro para envio de e-mail pelo servidor ou serviço próprio */
  //       if (sendServerWhatsApp()) {
  //         history.push('/whatsapp', {
  //           background: location,
  //           tipo: whatsAppTipo.WHATSAPP_CARRINHO,
  //           paraEmpresa,
  //           data: { attachment: blobFile },
  //         });
  //       } else {
  //         const formData = new FormData();
  //         formData.append('file', blobFile);

  //         const response = await api.post('email', formData);
  //         const { path } = response.data;

  //         const subject = encodeURIComponent(
  //           `Catálogo Eletrônico - Lista de Compras`
  //         );
  //         const body = encodeURIComponent(
  //           `Olá,\n\nSegue link para download da lista de compras:\n${path}\n\nAssiste - Catálogo Eletrônico`
  //         );

  //         /** cria um link para o processo de download */
  //         const link = document.createElement('a');
  //         link.href = `mailto:nome@endereco.com?subject=${subject}&body=${body}`;

  //         document.body.appendChild(link);
  //         link.click();

  //         document.body.removeChild(link);
  //       }
  //     } catch (err) {
  //       AppError(err);
  //     }
  //   },
  //   [location, itensCarrinho]
  // );

  const handleShared = useCallback(async () => {
    navigator.vibrate(200);

    const { userId, name, idEmpresa } = profile;

    const obs = `Token de compartilhamento criado pelo usuário ${userId} - ${name}`;

    const { idCatalogo } = itensCarrinho.itens[0];

    const itemQtdForToken = carrinho.map((i) => {
      const {
        idItem,
        quantidadeTotal,
        idMaterial,
        idPagina: idPag,
        codimate,
        imagemCatalogo,
      } = i;

      return `&IDPAG_${idItem}=${idPag}&IDI=${idItem}&IDMAT_${idItem}=${idMaterial}&CODMAT_${idItem}=${codimate}&QTD_${idItem}=${quantidadeTotal}&IMG_${idItem}=${imagemCatalogo}`;
    });

    const { data } = await api.post(
      `empresa/${idEmpresa}/catalogo/${idCatalogo}/token-acesso`,
      {
        nome: 'Compartilhamento',
        duracao: 3, // dias
        observacao: obs,
        tipo: 0,
        info: itemQtdForToken,
      }
    );

    if (!data) {
      toast.error(
        'Erro na geração do token de compartilhamento, tente novamente mais tarde!'
      );
    }

    const { nanoId } = data; // token

    const { pathname, search } = location;

    // const locationShared = window.location.href.replaceAll(
    //   `${pathname}${search}`,
    //   `/catalogo-token?token=${token}`
    // );

    const locationSharedNanoId = window.location.href.replaceAll(
      `${pathname}${search}`,
      `/catalogo-token?ass=${nanoId}`
    );

    // const fmtLocationShared = locationShared.replaceAll(',', '');
    const fmtLocationSharedNanoId = locationSharedNanoId.replaceAll(',', '');

    // const urlShared = `${fmtLocationShared}${carrinho.map((i) => {
    //   const { idItem, quantidadeTotal } = i;
    //   return `&IDI=${idItem}&IT_${idItem}QTD=${quantidadeTotal}`;
    // })}`;

    // const fmtUrlShared = urlShared.replaceAll(',', '');

    // setUrlShared(fmtLocationSharedNanoId);

    if (navigator.canShare) {
      try {
        await navigator
          .share({
            title: 'CDI - Catálogo Digital Interativo',
            text: 'Catálogo disponibilizado pela Assiste Engenharia',
            url: fmtLocationSharedNanoId,
          })
          .then(() => console.log('Compartilhado com sucesso!'));
      } catch (error) {
        console.log(error);
        toast.info('Volte para compartilhar quando desejar!');
      }
    } else {
      alert('A API de compartilhamento não é suportada nesse browser.');
    }
  }, [carrinho, itensCarrinho, location, profile]);

  const handleConfirmar = useCallback(async () => {
    /** solicitação por token */
    if (action === opTipoAcao.INTEGRACAO_TOKEN) {
      handleEmail(true);
      return;
    }

    if (enviaEmailSolicitacao()) {
      const { adm, email, empresa, login, name, userId } = selectUser.profile;
      const { descricao, email: emailEmpresa, idEmpresa, url } = empresa;

      const emailData = {
        adm,
        email,
        empresa,
        login,
        name,
        userId,
        descricao,
        emailEmpresa,
        idEmpresa,
        url,
      };

      /**
       * CHAMAR A TELA DE ENVIO DE E-MAIL IGUAL ESTA EM
       * EXPORTAR LISTA DE COMPRAS > ENVIAR E
       */

      handleEmail({ paraEmpresa: false, emailData });
      return;
    }

    try {
      const {
        extCodiDiv2,
        extNumeOS,
        extObservacao,
        extUsuario,
        extExtra01,
        extExtra02,
        extExtra03,
        extExtra04,
      } = itensCarrinho;

      const response = await api.post('/solicitacao', {
        extCodiDiv2,
        extNumeOS,
        extObservacao,
        extUsuario,
        extExtra01,
        extExtra02,
        extExtra03,
        extExtra04,
        itensCarrinho: itensCarrinho.itens,
      });

      const { idSolicitacao } = response.data;

      /** limpa itens do carrinho */
      dispatch(limpaCarrinho());

      /** redireciona para página de solicitação */
      history.push('/checkout', { id: idSolicitacao });
    } catch (err) {
      AppError(err);
    }
  }, [dispatch, itensCarrinho, action, handleEmail]);

  /** sincroniza rótulos */
  const rotuloExtExtra01 = useMemo(() => labelExtExtra01(), []);
  const rotuloExtExtra02 = useMemo(() => labelExtExtra02(), []);
  const rotuloExtExtra03 = useMemo(() => labelExtExtra03(), []);
  const rotuloExtExtra04 = useMemo(() => labelExtExtra04(), []);

  const redirectToPage = useCallback((idCatalogo, idPagina) => {
    api
      .get(`/catalogo/${idCatalogo}/nivel-classificacao/pagina/${idPagina}`)
      .then((response) => {
        const { data } = response;

        const {
          idNivel,
          relacNivel: { nivel },
        } = data;

        history.push(
          `/catalogo.partes/${idCatalogo}?IDN_${nivel}=${idNivel}&IDP=${idPagina}`
        );
      })
      .catch((erro) => {
        console.error(erro);
      });
  }, []);

  return (
    <Container>
      <TitleBar back title={SELECTED_MATERIALS[idioma]} width={950} />
      <Wrapper>
        {itensCarrinho.itens.length > 0 ? (
          <Form initialData={itensCarrinho} onSubmit={handleConfirmar}>
            <Cart.Header>
              <Cart.HeaderTitle>
                <strong>{YOUR_REQUEST[idioma]}</strong>
                <span>{REVIEW_ITEMS_BEFORE_SUBMITTING[idioma]}</span>
              </Cart.HeaderTitle>
              <Cart.HeaderMeta>
                <Cart.Count>
                  {itensCarrinho.itens.length}{' '}
                  {itensCarrinho.itens.length === 1
                    ? ITEM[idioma]
                    : ITEMS[idioma]}
                </Cart.Count>
                {/* <Cart.Tag>Sem valores</Cart.Tag> */}
              </Cart.HeaderMeta>
            </Cart.Header>

            <Table>
              <thead>
                <tr>
                  <th> </th>
                  <th>Partnumber</th>
                  <th>Descrição</th>
                  <th>Quantidade</th>
                  <th> </th>
                </tr>
              </thead>
              <tbody>
                {itensCarrinho.itens.map((item, index) => (
                  <RowMaster key={index} noCursoPointer>
                    <td>
                      <Wrapper.BtnImg
                        onClick={() =>
                          redirectToPage(item.idCatalogo, item.idPagina)
                        }
                      >
                        <Cart.ItemNo>{index + 1}</Cart.ItemNo>
                        <img src={item.imagemCatalogo} alt="Imagem catálogo" />
                      </Wrapper.BtnImg>
                    </td>
                    <td>
                      <strong>{item.partnumber}</strong>
                    </td>
                    <td>
                      <Table.Description>
                        <strong>{item.descricao}</strong>
                        <span>{`${MODEL[idioma]}: ${item.modelo}`}</span>
                        <span>{`${MANUFACTURER[idioma]}: ${item.fabricante.descricao}`}</span>
                        {/* <span>{`Fabricante: ${item.materialFabricante.descricao}`}</span> */}
                        {/* <span>{`Fabricante: ${item.materialEmpresa}`}</span> */}
                        {item.materialEmpresa ? (
                          <>
                            <span>{`Código ERP: ${item.materialEmpresa.codimate}`}</span>
                            {item.materialEmpresa.paralelo === '1' && (
                              <Table.Error>
                                Atenção: O material selecionado está cadastrado
                                como não original
                              </Table.Error>
                            )}
                          </>
                        ) : (
                          !ocultaERPHome && (
                            <Table.Error>
                              {NO_ERP_CODE_RELATED_TO_MATERIAL[idioma]}
                            </Table.Error>
                          )
                        )}

                        {!criaItemOSSisma() && itensCarrinho.extNumeOS && (
                          <Scope path={`extItensOS[${index}]`}>
                            <InputViewer
                              id="itemKey"
                              name="itemKey"
                              defaultValue={index}
                              isHidden
                            />
                            <Table.Combo>
                              Item O.S.:
                              <Select
                                id="itemValue"
                                name="itemValue"
                                options={item.itemOSFormatado}
                                isSearchable
                                defaultValue={
                                  item.itemOS
                                    ? item.itemOSFormatado.filter(
                                        (i) => i.value === item.itemOS
                                      )
                                    : item.itemOSFormatado[0]
                                }
                                width={300}
                                onChange={(select) =>
                                  handleSelecionado(
                                    select,
                                    item.idCatalogo,
                                    item.idPagina,
                                    item.idItem,
                                    item.idMaterial,
                                    item.materialEmpresa
                                  )
                                }
                              />
                            </Table.Combo>
                          </Scope>
                        )}
                        {criaItemOSSisma() && (
                          <>
                            {(usaMotivoFalha() ||
                              usaAgenteCausa() ||
                              usaSecaoTrab()) && (
                              <WrapperItemOS>
                                <ItemOSTitle>Criação Item OS:</ItemOSTitle>
                                <WrapperTableItemOS>
                                  <ItemOSTableLabel>
                                    {usaMotivoFalha() && (
                                      <span>Agente Causa: </span>
                                    )}
                                    {usaAgenteCausa() && (
                                      <span>Motivo Falha: </span>
                                    )}
                                    {usaSecaoTrab() && (
                                      <span>Seção Trabalho: </span>
                                    )}
                                  </ItemOSTableLabel>
                                  <ItemOSTableContent>
                                    {usaMotivoFalha() && (
                                      <p>
                                        <span>
                                          {item.agenteCausa.codiAgente} -{' '}
                                        </span>
                                        <span>
                                          {item.agenteCausa.descricao}
                                        </span>
                                      </p>
                                    )}
                                    {usaAgenteCausa() && (
                                      <p>
                                        <span>
                                          {item.motivoFalha.codiMofa} -{' '}
                                        </span>
                                        <span>
                                          {item.motivoFalha.descricao}
                                        </span>
                                      </p>
                                    )}
                                    {usaSecaoTrab() && (
                                      <p>
                                        <span>
                                          {item.secaoTrab.codiSetr} -{' '}
                                        </span>
                                        <span>{item.secaoTrab.descrResum}</span>
                                      </p>
                                    )}
                                  </ItemOSTableContent>
                                </WrapperTableItemOS>
                              </WrapperItemOS>
                            )}
                            <WrapperItemOS>
                              <ItemOSTitle>Composição:</ItemOSTitle>
                              <WrapperTableItemOS>
                                <ItemOSTableLabel>
                                  <span>Sistema: </span>
                                  <span>Local: </span>
                                </ItemOSTableLabel>
                                <ItemOSTableContent>
                                  <p>
                                    <span>{item.sistema.codiSist} - </span>
                                    <span>{item.sistema.descricao}</span>
                                  </p>
                                  <p>
                                    <span>{item.local.codiLoca} - </span>
                                    <span>{item.local.descricao}</span>
                                  </p>
                                </ItemOSTableContent>
                              </WrapperTableItemOS>
                            </WrapperItemOS>
                          </>
                        )}
                      </Table.Description>
                    </td>
                    <td>
                      <strong>
                        <Table.Quantity>
                          <button
                            type="button"
                            onClick={() =>
                              handleRemover(
                                item.idCatalogo,
                                item.idPagina,
                                item.idItem,
                                item.idMaterial,
                                item.materialEmpresa
                              )
                            }
                          >
                            <MdChevronLeft size={25} />
                          </button>
                          <span>{item.quantidadeTotal}</span>
                          <button
                            type="button"
                            onClick={() =>
                              handleAdicionar(
                                item.idCatalogo,
                                item.idPagina,
                                item.idItem,
                                item.idMaterial,
                                item.materialEmpresa
                              )
                            }
                          >
                            <MdChevronRight size={25} />
                          </button>
                        </Table.Quantity>
                      </strong>
                    </td>
                    <td>
                      <Table.Action>
                        <Table.BtnRemove
                          type="button"
                          onClick={() =>
                            handleExcluir(
                              item.idCatalogo,
                              item.idPagina,
                              item.idItem,
                              item.idMaterial,
                              item.materialEmpresa
                            )
                          }
                        >
                          <MdDelete size={25} />
                        </Table.BtnRemove>
                      </Table.Action>
                    </td>
                  </RowMaster>
                ))}
              </tbody>
            </Table>

            <Section>
              <Form.Title>{OTHER_INFORMATION[idioma]}</Form.Title>
              <Form.Column>
                <Form.Row>
                  <InputViewer
                    id="nome"
                    name="nome"
                    label={`${REQUESTER[idioma]}:`}
                    asRow
                  />
                </Form.Row>
                {itensCarrinho.extNumeOS && (
                  <>
                    <InputViewer id="extCodiDiv2" name="extCodiDiv2" isHidden />
                    <Form.Row>
                      <InputViewer
                        id="extNumeOS"
                        name="extNumeOS"
                        label="Nº OS:"
                        asRow
                      />
                    </Form.Row>
                  </>
                )}
                {itensCarrinho.extUsuario && (
                  <Form.Row>
                    <InputViewer
                      id="extUsuario"
                      name="extUsuario"
                      label="Usuário:"
                      asRow
                    />
                  </Form.Row>
                )}
                {itensCarrinho.extExtra01 && (
                  <Form.Row>
                    <InputViewer
                      id="extExtra01"
                      name="extExtra01"
                      label={rotuloExtExtra01}
                      asRow
                    />
                  </Form.Row>
                )}
                {itensCarrinho.extExtra02 && (
                  <Form.Row>
                    <InputViewer
                      id="extExtra02"
                      name="extExtra02"
                      label={rotuloExtExtra02}
                      asRow
                    />
                  </Form.Row>
                )}
                {itensCarrinho.extExtra03 && (
                  <Form.Row>
                    <InputViewer
                      id="extExtra03"
                      name="extExtra03"
                      label={rotuloExtExtra03}
                      asRow
                    />
                  </Form.Row>
                )}
                {itensCarrinho.extExtra04 && (
                  <Form.Row>
                    <InputViewer
                      id="extExtra04"
                      name="extExtra04"
                      label={rotuloExtExtra04}
                      asRow
                    />
                  </Form.Row>
                )}
                {itensCarrinho.extObservacao && (
                  <Form.Row>
                    <InputViewer
                      id="extObservacao"
                      name="extObservacao"
                      type="textarea"
                    />
                  </Form.Row>
                )}
              </Form.Column>
            </Section>

            <Footer>
              <ActionMenu
                topContainer
                Icon={EXPORT_SHOPPING_LIST[idioma]}
                onExportCSV={handleExportar}
                onMail={!enviaEmailSolicitacao() && handleEmail}
                onWhatsApp={handleShared}
              />

              <Footer.Actions>
                <Footer.Count>
                  {itensCarrinho.itens.length}{' '}
                  {itensCarrinho.itens.length === 1
                    ? ITEM[idioma]
                    : ITEMS[idioma]}
                </Footer.Count>

                {utilizaSolicitarPecas() &&
                  (!app ||
                    action === opTipoAcao.INTEGRACAO_CATALOGO ||
                    action === opTipoAcao.INTEGRACAO_TOKEN) && (
                    <Footer.Submit type="submit">
                      {action === opTipoAcao.INTEGRACAO_TOKEN
                        ? REQUEST_QUOTE[idioma]
                        : REQUEST_PARTS[idioma]}
                    </Footer.Submit>
                  )}
              </Footer.Actions>

              {/* {(!app || action === opTipoAcao.INTEGRACAO_CATALOGO) && (
                <Footer.Submit type="submit">
                  {action === opTipoAcao.INTEGRACAO_TOKEN
                    ? 'Solicitar Orçamento'
                    : 'Solicitar Peças'}
                </Footer.Submit>
              )} */}
            </Footer>
          </Form>
        ) : (
          <Wrapper.NotFound>
            <MdShoppingCart size={46} />
            <strong>{NO_ITEM_ADDED_TO_CART[idioma]}</strong>
            <span>{BROWSE_CATALOG_AND_ADD_PARTS[idioma]}</span>
            <Wrapper.BackButton type="button" onClick={() => history.push('/')}>
              <MdArrowBack size={18} />
              {BACK_TO_CATALOG[idioma]}
            </Wrapper.BackButton>
          </Wrapper.NotFound>
        )}
      </Wrapper>
    </Container>
  );
}

export default Carrinho;
